/* eslint-disable no-sequences */

import React, { useState, useEffect } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import { Link, useParams, useSearchParams } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import { getKontrakDetail, getAccesses, downloadDraft } from '../../../api/modules/kontrak'
import { useNavigate } from 'react-router-dom'
import swal from 'sweetalert'
import { Spinner } from 'react-bootstrap'
import AddRemoveJadwal from './AddRemoveJadwal'
import {
  getKontrakAll,
  approve,
  syncKontrak,
  resubmitAdditionalText,
} from '../../../api/modules/kontrak'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { useDispatch, useSelector } from 'react-redux'
import { setGetNotif } from '../../../_metronic/redux/content'
import { create, getFile, deleteFile } from '../../../api/modules/file'
import i18next from 'i18next'
import 'react-datepicker/dist/react-datepicker.css'
import InputGroup from 'react-bootstrap/InputGroup'
import Select from 'react-select'
import { getPlant2, getSloc, getUserDetail, getFooterContent } from '../../../api/modules/getdatalist'
import CustomUseEffect from './CustomUseEffect'
import {
  getMaterialGroup,
  getListMaterialAll,
  getDetailFileConfig,
} from '../../../api/modules/master-data/master'
import CurrencyInput from 'react-currency-input-field'
import { PopoverText } from '../../../components/Popover/Popover'
import { getRoleFlagList } from '../../../api/modules/master-data/master_2'
import { MultiSelect } from 'react-multi-select-component'
import { PriceFormater } from '../../../components/mikro/PriceFormater'
import { BeforePPNKontrak, AfterPPNKontrak } from '../../../components/mikro/PPNCalculator'
import { useAppSelector } from 'src/redux/hooks'
import { authSelector } from 'src/redux/slices/authSlices'
import { HakAkses } from 'src/components/mikro/getHakAkses'
import { BadgeColorKontrak } from 'src/components/BadgeColorKontrak'
import dateformat from 'src/utils/dateformat'
import { FieldProductSpec } from 'src/components/FieldProductSpec'
import { CheckSameIDAttachment } from 'src/components/mikro/CheckSameIDAttachment'
import ViewLetter from 'src/components/Letter/ViewLetter'
import { RichText } from 'src/components'
import Skeleton from 'react-loading-skeleton'
import * as TableUI from '../../../components/Table/Table'
import { InputFile } from 'src/app/components/InputFile'
import { handleDownloadAttachment } from 'src/app/helpers/file'

const KontrakDetail: React.FC = () => {
  const intl = useIntl()
  const dispath = useDispatch()
  const notif = useSelector((state: any) => state.notif.getNotif)
  const { roleId } = useAppSelector(authSelector)
  const hakAkses = HakAkses()

  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [show2, setShow2] = useState(false)
  const [show3, setShow3] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleClose1 = () => setShow1(false)
  const handleShow1 = () => {
    setShow1(true)
  }
  const handleClose2 = () => setShow2(false)
  const handleShow2 = () => setShow2(true)
  const handleClose3 = () => setShow3(false)
  const handleShow3 = () => setShow3(true)

  let role = 2

  const [kontrakDetail, setKontrakDetail] = useState<any>()

  const handleDetail = (data: any) => {
    setKontrakDetail(data)
    handleShow()
  }

  const { t } = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)

  // Detail
  const navigate = useNavigate()

  const handleSub = (sub: any) => {
    localStorage.setItem('sub', sub)

    navigate('/management/kontrak/detail/sub')
  }

  const handleSchedule = (sub: any) => {
    localStorage.setItem('sub', sub)
    handleShow()
  }
  // End Detail

  const [detail, setDetail] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [per, setPer] = useState(0)
  const [loading, setLoading] = useState(false)
  const [loadingModal, setLoadingModal] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [orderId, setOrderId] = useState('')
  const [kontrakId, setKontrakId] = useState('')
  const [kontrakIdSap, setKontrakIdSap] = useState('')
  const [produsen, setProdusen] = useState('')
  const [masaBerlaku, setmasaBerlaku] = useState('')
  const [subDetail, setsubDetail] = useState<any[]>([])
  const [kontrak, setKontrak] = useState<any[]>([])
  const [details, setDetails] = useState<any>()
  const [fixedPrice, setFixedPrice] = useState<any>()
  const [totalQuantum, setTotalQuantum] = useState<any>()
  const [totalQ, setTotalQ] = useState<any>()
  const [quantumApprove, setQuantumApprove] = useState<any>()
  const [kantongApprove, setKantongApprove] = useState<any>()
  const [kantongUnit, setKantongUnit] = useState<any>()
  const [beforePpn, setBeforePpn] = useState<any>()
  const [revisionNote, setRevisionNote] = useState<any>()
  const [rejectNote, setRejectNote] = useState<any>()
  const [isUpload, setIsUpload] = useState(false)
  const [stateApproval, setStateApproval] = useState(false)
  const [accesses, setAccesses] = useState<any>()
  const [custGroup, setCustGroup] = useState('')
  const [sektorid, setsektorid] = useState(0)
  const [matgroup, setMatgroup] = useState('')
  const [matgroupdesc, setMatgroudesc] = useState('')
  const [matNumber, setMatNumber] = useState('')
  const [matUnit, setMatUnit] = useState('')
  const [matDesc, setMatDesc] = useState('')
  const [assignerName, setassignerName] = useState('')
  const [assignerPos, setassignerPos] = useState('')
  const [roleUser, setRoleUser] = useState('')

  const [customerCode, setCustomerCode] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')
  const [ppn, setppn] = useState(0)
  const [amandement, setAmandement] = useState<any>('')
  const [id, setId] = useState<any>('')
  const [downloadOnly, setDownloadOnly] = useState(false)
  const [dist, setDist] = useState<any>('')

  const [tempIndex, setTempIndex] = useState(0)
  const [payloadID, setPayloadID] = useState<any[]>([])
  const [payloadSloc, setPayloadSloc] = useState<any[]>([])
  const [payloadSlocDesc, setPayloadSlocDesc] = useState<any[]>([])
  const [payloadPlantID, setPayloadPlantID] = useState<any[]>([])
  const [payloadPlantDesc, setPayloadPlantDesc] = useState<any[]>([])
  const [payloadType, setPayloadType] = useState<any[]>([])
  const [payloadDesc, setPayloadDesc] = useState<any[]>([])
  const [payloadName, setPayloadName] = useState<any[]>([])
  const [payloadMaterial, setPayloadMaterial] = useState<any[]>([])
  const [payloadUnit, setPayloadUnit] = useState<any[]>([])
  const [payloadSpec, setPayloadSpec] = useState<any[]>([])
  const [payloadQuantum, setPayloadQuantum] = useState<any[]>([])
  const [payloadHarga, setPayloadHarga] = useState<any[]>([])
  const [payloadPPH22, setPayloadPPH22] = useState<any[]>([])
  const [status, setStatus] = useState(0)
  const [plant, setPlant] = useState('')
  const [plantDesc, setPlantDesc] = useState('')
  const [plantNameEn, setPlantNameEn] = useState('')
  const [slocId, setslocId] = useState<any>('')
  const [slocDesc, setslocDesc] = useState<any>('')
  const [fullsloc, setFullSloc] = useState<any[]>([])
  const [tempRole, setTempRole] = useState<any[]>([])
  const [fullRole, setFullRole] = useState<any[]>([])
  const [idItemEdit, setIdItemEdit] = useState<any>('')
  const [plantEdit, setPlantEdit] = useState<any>('')
  const [plantDescEdit, setPlantDescEdit] = useState<any>('')
  const [slocEdit, setSlocEdit] = useState<any>('')
  const [slocDescEdit, setSlocDescEdit] = useState<any>('')
  const [fullPlant, setFullPlant] = useState<any[]>([])
  const [plantt, setPlantt] = useState('')
  const [ordersubdetail, setordersubdetail] = useState<any[]>([])
  const [companyCode, setCompanyCode] = useState<any>('')
  const [spec, setSpec] = useState<any>('')
  const [quantumEdit, setQuantumEdit] = useState<any>('')
  const [hargaEdit, setHargaEdit] = useState<any>('')
  const [SOSAPNum, setSOSAPNum] = useState<any>()
  const [customerShip, setCustomerShip] = useState<any>('')
  const [reasonReject, setReasonReject] = useState<any>('')
  const [fileBox, setFileBox] = useState<any>({})
  const [salesOption, setSalesOption] = useState<any>('')
  const [customerTitle, setCustomerTitle] = useState('')
  const [userDetail, setUserDetail] = useState<any>({})
  const [footer, setFooter] = useState<any>({})
  const [salesOrg, setSalesOrg] = useState('')
  const [showLetter, setShowLetter] = useState(false)
  const [imgHeader, setImgHeader] = useState<any>()
  const [imgFooter, setImgFooter] = useState<any>()
  const params = useParams()
  let [searchParams, setSearchParams] = useSearchParams();

  const statusAmandement = useSelector((state: any) => state.contractReducer.isAmendment)
  const ContractID = params?.id || sessionStorage.getItem('kid')

  const [loadingDownloadDraft, setLoadingDownloadDraft] = useState<boolean>(false)

  const getDetail = async () => {
    setLoading(true)
    const res = await getKontrakDetail(
      params?.id || sessionStorage.getItem('kid'),
      localStorage.getItem('credential'),
      searchParams?.get('is_amend') || statusAmandement
    )
    const data = res.data.data
    setassignerPos(res.data.data.assigner_position)
    setassignerName(res.data.data.assigner_name)
    setReasonReject(res?.data?.data?.reject_note)
    setId(res.data.data?.id)
    setSOSAPNum(res.data.data?.sap_number)
    setStatus(res.data.data.status)
    setAmandement(res.data.data.is_amendment)
    setsektorid(data.sector_id)
    setStateApproval(res.data.data.show_btn_approve)
    setDetail(data)
    setOrderId(data.id)
    setDist(data?.sip_order?.pengajuan_order?.distribution_channel)
    setKontrakId(data.contract_number)
    setKontrakIdSap(data.sip_order_id)
    setProdusen(data.anper?.name)
    setmasaBerlaku(data.validity_date_to)
    setsubDetail(data.order_sub_details)
    setCustomerCode(data.customer.customer_code)
    setCustomerName(data.customer.name)
    setCustomerTitle(res.data.data.customer?.title)
    setCustomerAddress(data.customer.address)
    setPage(data.current_page)
    setPer(data.per_page)
    setLoading(false)
    setNumberURL(data.links)
    setCustGroup(res.data.data.customer?.customer_account_group)
    setppn(res.data.data.order_sub_details[0]?.ppn)
    setordersubdetail(res.data.data.order_sub_details)
    setCompanyCode(data?.anper?.code)
    setFixedPrice(data?.grand_total)
    setSalesOrg(res.data.data?.sales_org_code)
    getImg(res.data.data.sales_org_code)
    setTitle(res.data.data?.additional_texts?.title)
    setCustomer_pic_name(res.data.data?.additional_texts?.customer_pic_name)
    setCustomer_pic_position(res.data.data?.additional_texts?.customer_pic_position)
    setTerms_and_conditions(res.data.data?.additional_texts?.terms_and_conditions)
    setMail_body(res.data.data?.additional_texts?.mail_body || 'Bersama ini kami sampaikan persetujuan pembelian dengan rincian sebagai berikut:')
    setCustomer_attn(res.data.data?.additional_texts?.customer_attn)
    setPort_of_discharge(res.data.data?.additional_texts?.port_of_discharge)
    setLain_lain(res.data.data?.additional_texts?.lain_lain)
    setKeterangan(res.data.data?.additional_texts?.keterangan)
    setTextPenutup(res.data.data?.additional_texts?.text_penutup)
    setNoExport(res.data.data?.additional_texts?.no_izin_export)

    setTitleEn(res.data.data?.additional_texts?.title_en)
    setMail_bodyEn(res.data.data?.additional_texts?.mail_body_en || 'We hereby convey the purchase agreement with the following details:')
    setCustomer_attnEn(res.data.data?.additional_texts?.customer_attn_en)
    setTextPenutupEn(res.data.data?.additional_texts?.text_penutup_en)
    setLain_lainEn(res.data.data?.additional_texts?.lain_lain_en)
    setKeteranganEn(res.data.data?.additional_texts?.keterangan_en)
    setTerms_and_conditionsEn(res.data.data?.additional_texts?.terms_and_conditions_en)

    setTitle_(res.data.data?.additional_texts?.title)
    setCustomer_pic_name_(res.data.data?.additional_texts?.customer_pic_name)
    setCustomer_pic_position_(res.data.data?.additional_texts?.customer_pic_position)
    setTerms_and_conditions_(res.data.data?.additional_texts?.terms_and_conditions)
    setMail_body_(res.data.data?.additional_texts?.mail_body)
    setCustomer_attn_(res.data.data?.additional_texts?.customer_attn)
    setPort_of_discharge_(res.data.data?.additional_texts?.port_of_discharge)
    setLain_lain_(res.data.data?.additional_texts?.lain_lain)
    setKeterangan_(res.data.data?.additional_texts?.keterangan)
    setTextPenutup_(res.data.data?.additional_texts?.text_penutup)
    setNoExport_(res.data.data?.additional_texts?.no_izin_export)

    if(res.data.data?.sip_order){
      setSipStatus(res.data.data?.sip_order?.status)
    }

    let beforePpn = data.order_sub_details.reduce((a: any, b: any) => a + b.price_before_ppn, 0)
    setBeforePpn(beforePpn)

    const tempID: string[] = []
    data.order_sub_details?.forEach((data: any) => {
      tempID.push(data.id)
    })
    setPayloadID(tempID)

    const tempPlant: string[] = []
    data.order_sub_details?.forEach((data: any) => {
      tempPlant.push(data.plant)
    })
    setPayloadPlantID(tempPlant)

    const tempPlantDesc: string[] = []
    data.order_sub_details?.forEach((data: any) => {
      tempPlantDesc.push(data.plant_desc)
    })
    setPayloadPlantDesc(tempPlantDesc)

    const tempSlac: string[] = []
    data.order_sub_details?.forEach((data: any) => {
      tempSlac.push(data.sloc)
    })
    setPayloadSloc(tempSlac)

    const tempSlacDesc: string[] = []
    data.order_sub_details?.forEach((data: any) => {
      tempSlacDesc.push(data.sloc_description)
    })
    setPayloadSlocDesc(tempSlacDesc)

    const tempProductType: string[] = []
    data.order_sub_details?.forEach((data: any) => {
      tempProductType.push(data.product_type)
    })
    setPayloadType(tempProductType)

    const tempProductDesc: string[] = []
    data.order_sub_details?.forEach((data: any) => {
      tempProductDesc.push(data.product_type_desc)
    })
    setPayloadDesc(tempProductDesc)

    const tempProductName: string[] = []
    data.order_sub_details?.forEach((data: any) => {
      tempProductName.push(data.product_name)
    })
    setPayloadName(tempProductName)

    const tempMaterial: string[] = []
    data.order_sub_details?.forEach((data: any) => {
      tempMaterial.push(data.material_number)
    })
    setPayloadMaterial(tempMaterial)

    const tempUnits: string[] = []
    data.order_sub_details?.forEach((data: any) => {
      tempUnits.push(data.unit)
    })
    setPayloadUnit(tempUnits)

    const tempSpec: string[] = []
    data.order_sub_details?.forEach((data: any) => {
      tempSpec.push(data.product_spec)
    })
    setPayloadSpec(tempSpec)

    const tempQuantum: number[] = []
    data.order_sub_details?.forEach((data: any) => {
      tempQuantum.push(parseFloat(data.quantum_contract))
    })

    setPayloadQuantum(tempQuantum)
    setTotalQ(tempQuantum.reduce((a: any, b: any) => a + b, 0))
    setQuantumApprove(
      data.order_sub_details.reduce(
        (a: any, b: any) =>
          b.product_type != '8105' ? a + (parseFloat(b.quantum_contract) || 0) : a + 0,
        0
      )
    )
    setKantongApprove(
      data.order_sub_details.reduce(
        (a: any, b: any) =>
          b.product_type == '8105' ? a + (parseFloat(b.quantum_contract) || 0) : a + 0,
        0
      )
    )
    setKantongUnit(data.order_sub_details?.[0]?.unit)

    const tempHarga: number[] = []
    data.order_sub_details?.forEach((data: any) => {
      tempHarga.push(parseFloat(data?.price_contract))
    })
    setPayloadHarga(tempHarga)

    setDetails(res.data.data)
    setCustomerShip(
      data?.customer_ship?.title
        ? data?.customer_ship?.title + ' ' + data?.customer_ship?.name
        : data?.customer_ship?.name
    )
    setEstimate(res.data.data.validity_date_from.slice(0, 10))
    setEstimateTo(res.data.data.validity_date_to.slice(0, 10))
    setLoading(false)
    setNumberURL(res.data.data.links)
    let totalQuantum = res.data.data.order_sub_details.reduce(
      (a: any, b: any) => a + (parseFloat(b['quantum_contract']) || 0),
      0
    )
    setQuantumApprove(
      data.order_sub_details.reduce(
        (a: any, b: any) =>
          b.product_type != '8105' ? a + (parseFloat(b.quantum_contract) || 0) : a + 0,
        0
      )
    )
    setKantongApprove(
      data.order_sub_details.reduce(
        (a: any, b: any) =>
          b.product_type == '8105' ? a + (parseFloat(b.quantum_contract) || 0) : a + 0,
        0
      )
    )
    setKantongUnit(data.order_sub_details?.[0]?.unit)
    setFixedPrice(data?.grand_total)

    const tempPPH22: string[] = []
    setPPh22(res.data?.data?.amount_of_pph22)
    res.data.data.order_sub_details?.forEach((data: any) => {
      tempPPH22.push(data.pph22)
    })
    setPayloadPPH22(tempPPH22)
  }

  const [PPh22, setPPh22] = useState(false)

  const getImg = async (sales: any) => {
    getDetailFileConfig(sales, 'kop-header').then((res) => {
      setImgHeader(res.data.data)
    })
    getDetailFileConfig(sales, 'kop-footer').then((res) => {
      setImgFooter(res.data.data)
    })
  }

  useEffect(() => {
    const getKontrak = async () => {
      setLoading(true)
      const res = await getKontrakAll(localStorage.getItem('credential'))
      setKontrak(res.data.data.data)
      setLoading(false)
      setNumberURL(res.data.data.links)
      setCustGroup(res.data)
      // const kontrakid = useParams()
      // const thisKontrak = kontrak.find((kontrak) => kontrak.id == kontrakid.id)
    }

    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }

    getAccessMenu()
    getAllRoleList()
    role()
    getKontrak()
    getDetail()
  }, [])

  const [indexMat, setIndexMat] = useState<any>('')
  const [fq, setFq] = useState<any>('')

  CustomUseEffect(() => {
    const getPlantLoc = async () => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')

      await getSloc(plant, language, indexMat, fq, '')
        .then((res) => {
          setFullSloc(res.data.data)
        })
        .catch((err) => {
          swal({
            title: t(err.response.data.message),
            icon: 'error',
          })
          setFullSloc([])
        })
    }
    getPlantLoc()
  }, [plant])

  const [listMaterial, setListMaterial] = useState<any>()
  const [listProduct, setListProduct] = useState<any>()

  const handleOsd = async (saless: any, mat: any, plantt: any, matGroup: any) => {
    handleShow1()
    setLoadingModal(true)
    let planttt = plantt != 'null' ? plantt : ''
    setIndexMat(mat)
    await getPlant2(saless, dist, '').then((res: any) => {
      let temparray: any[] = [{ value: 0 + '~#~', label: t('Pilih-plant') }]
      res.data.data.forEach((item: any) => {
        temparray.push({
          value: item.plant + '~#~' + item.plant_name,
          label: item.plant + ' - ' + item.plant_name,
        })
      })
      setFullPlant(temparray)
    })
    await getMaterialGroup().then((res) => {
      setListMaterial(res.data.data)
    })
    await getListMaterialAll(planttt, dist, companyCode, matGroup).then((res) => {
      setListProduct(res.data.data)
    })
    setLoadingModal(false)
  }

  CustomUseEffect(() => {
    const getPlantLoc = async () => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')

      await getSloc(plant, language, matNumber, fq, '')
        .then((res) => {
          setFullSloc(res.data.data)
        })
        .catch((err) => {
          swal({
            title: t(err.response.data.message),
            icon: 'error',
          })
          setFullSloc([])
        })
    }
    getPlantLoc()
  }, [plant, matNumber])

  CustomUseEffect(() => {
    const getListMat = async () => {
      await getListMaterialAll(plant, dist, companyCode, matgroup).then((res) => {
        setListProduct(res.data.data)
      })
    }
    getListMat()
  }, [plant, matgroup])

  CustomUseEffect(() => {
    let totalQ = payloadQuantum.reduce((a: any, b: any) => a + b, 0)
    setTotalQ(totalQ)

    let totalQuantum = payloadQuantum.reduce((acc, curr, index) => {
      return payloadType[index] != '8105' ? acc + curr : acc + 0
    }, 0)
    setQuantumApprove(totalQuantum)

    let totalKantong = payloadQuantum.reduce((acc, curr, index) => {
      return payloadType[index] == '8105' ? acc + curr : acc + 0
    }, 0)
    setKantongApprove(totalKantong)
  }, [payloadQuantum[tempIndex]])

  CustomUseEffect(() => {
    setBeforePpn(
      payloadQuantum.reduce((a: any, b: any) => a + b, 0) *
      payloadHarga.reduce((a: any, b: any) => a + b, 0)
    )
  }, [payloadHarga[tempIndex], payloadQuantum[tempIndex]])

  CustomUseEffect(() => {
    let amount_ppn = (payloadHarga.reduce((a: any, b: any) => a + b, 0) / 100) * ppn
    let total_price =
      payloadQuantum.reduce((a: any, b: any) => a + b, 0) *
      (payloadHarga.reduce((a: any, b: any) => a + b, 0) + amount_ppn)
    let exclude_ppn = total_price / ((ppn + 100) / 100)
    let amount_pph22 = (exclude_ppn / 100) * payloadPPH22[tempIndex]
    setFixedPrice(total_price - amount_pph22)
  }, [payloadHarga[tempIndex], payloadQuantum[tempIndex]])

  const separator = (value: any, state1: any, state2: any) => {
    const temp = value.split('~#~')
    state1(temp[0])
    state2(temp[1])
  }

  const checkMandatory = () => {
    if (plant == '' || plant == '0') return t('isi') + t('sub-order-gudang')
    else if (slocDesc == '' || slocDesc == '0') return t('isi') + t('sloc')
    else if (
      parseFloat(kontrakDetail.fixed_quantum_edit) >
      parseFloat(kontrakDetail?.quantum_contract) + parseFloat(kontrakDetail?.left_over_qty_sip)
    )
      return t('CREATE_CONTRACT.VALIDATE.EDIT_CONTRACT')
    else if (idSektor == 3 && (!plantNameEn || plantNameEn == '')) return t('isi') + t('sub-order-gudang') + ' (EN)'
    else if (idSektor == 3 && (!productNameEn || productNameEn == '')) return t('isi') + t('sub-order-produk') + ' (EN)'
    else return 'nothing'
  }

  const handleEditPlant = async () => {
    const mandatory = checkMandatory()
    if (mandatory == 'nothing') {
      const newArray = [...ordersubdetail]
      newArray[tempIndex] = {
        ...newArray[tempIndex],
        at_sales_option: salesOption,
        material_desc_en: productNameEn,
        plant_desc_en: plantNameEn,
      }

      setordersubdetail(newArray)

      const temparray: any[] = [...payloadPlantID]
      const temparray2: any[] = [...payloadPlantDesc]
      const temparray3: any[] = [...payloadSloc]
      const temparray4: any[] = [...payloadSlocDesc]
      const temparray5: any[] = [...payloadType]
      const temparray6: any[] = [...payloadDesc]
      const temparray7: any[] = [...payloadMaterial]
      const temparray8: any[] = [...payloadName]
      const temparray9: any[] = [...payloadSpec]
      const temparray10: any[] = [...payloadQuantum]
      const temparray11: any[] = [...payloadHarga]
      const tempUnits: any[] = [...payloadUnit]

      temparray[tempIndex] = plant
      temparray2[tempIndex] = plantDesc
      temparray3[tempIndex] = slocId
      temparray4[tempIndex] = slocDesc
      temparray5[tempIndex] = matgroup
      temparray6[tempIndex] = matgroupdesc
      temparray7[tempIndex] = matNumber
      temparray8[tempIndex] = matDesc
      temparray9[tempIndex] = spec || ''
      temparray10[tempIndex] = quantumEdit
      temparray11[tempIndex] = hargaEdit
      tempUnits[tempIndex] = matUnit

      setPayloadPlantID(temparray)
      setPayloadPlantDesc(temparray2)
      setPayloadSloc(temparray3)
      setPayloadSlocDesc(temparray4)
      setPayloadType(temparray5)
      setPayloadDesc(temparray6)
      setPayloadMaterial(temparray7)
      setPayloadUnit(tempUnits)
      setPayloadName(temparray8)
      setPayloadSpec(temparray9)
      setPayloadQuantum(temparray10)
      setPayloadHarga(temparray11)
      setSalesOption('')

      setordersubdetail((data: any[]) =>
        data.map((item) => {
          if (item.id === kontrakDetail.id) {
            return kontrakDetail
          }
          return item
        })
      )

      handleClose1()
      swal({
        title: `${t('Item updated')}`,
        icon: 'success',
      })
    } else {
      swal({
        title: mandatory,
        icon: 'error',
      })
    }
  }

  const handleApprove = async () => {
    setLoading(true)
    const res = await approve(sessionStorage.getItem('kid'), localStorage.getItem('credential'))

    swal({
      title: `${t('aprroveSuccess')}`,
      icon: 'success',
    }).then(() => {
      navigate('/management/kontrak')
      dispath(setGetNotif(!notif))
    })
  }

  const handleRevisi = async (note: any) => {
    let id = sessionStorage.getItem('kid')
    axios
      .post(
        `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
        }/contract/revision/${id}?revision_note=${note}&credentials=${localStorage.getItem(
          'credential'
        )}`,
        {
          revision_note: revisionNote,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        if (!response.data.error) {
          setIsUpload(true)
          swal({
            title: `${t('revisionSuccess')}`,
            icon: 'success',
          })
          dispath(setGetNotif(!notif))
        }
      })
      .catch((error) => { })
  }

  const handleReject = async (note: any) => {
    let id = sessionStorage.getItem('kid')
    axios
      .post(
        `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
        }/contract/reject/${id}?reject_note=${note}&credentials=${localStorage.getItem(
          'credential'
        )}`,
        {
          reject_note: rejectNote,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        if (!response.data.error) {
          setIsUpload(true)

          swal({
            title: `${t('rejectSuccess')}`,
            icon: 'success',
          })
          dispath(setGetNotif(!notif))
        }
      })
      .catch((error) => { })
  }

  const [showJadwal, setShowJadwal] = useState(false)
  const [ptypee, setPtype] = useState('')
  const [punit, setPunit] = useState('')
  const [jadwalID, setJadwalID] = useState('')
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [productNameEn, setProductNameEn] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState('')
  const [quantumContract, setQuantumContract] = useState('')
  const [idSektor, setIDSector] = useState(0)
  const [sipStatus, setSipStatus] = useState(0)

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', { maximumFractionDigits: 4 })
    } else {
      temp = tempTon.toLocaleString('id', { maximumFractionDigits: 4 })
    }

    setFixedQuantum(temp)
    setQuantumContract(temp)
  }

  const [loadingSkeleton, setLoadingSkeleton] = useState(false)

  const [showUpload, setShowUpload] = useState(false)
  const [allFiles, setAllFiles] = useState<any[]>([])
  const [files, setFiles] = useState({ file: null })
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [subOrderID, setSubOrderID] = useState('')

  const ambilAttachment = async (id: any, type: any = null) => {
    setLoadingSkeleton(true)
    setShowUpload(true)
    if (type) setAttachmentType(type)
    await getFile(type || attachmentType, id, localStorage.getItem('credential')!).then((res) => {
      handleShowAttachment(res.data.data)
    })
    setLoadingSkeleton(false)
  }

  const handleShowAttachment = (data: any) => {
    setAllFiles(data)
  }

  const clearFile = () => {
    const inputfile = document.getElementById('upload') as HTMLInputElement
    inputfile.value = ''
    const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement
    inputPrivate.checked = false
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment(subOrderID)
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
      }
    })
  }

  const handleUpload = async () => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    let temparray: any[] = []
    if (tempRole.length > 0) {
      tempRole.forEach((data: any) => {
        temparray.push(data.value)
      })
    }
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', subOrderID)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('roles', JSON.stringify(temparray))
    formdata.append('credentials', localStorage.getItem('credential')!)
    formdata.append('unique_number', subOrderID)
    formdata.append('unique_flag', 'new_contract_osd')
    await create(attachmentType, formdata)
      .then(
        (res) => {
          swal({
            title: `${t('document uploaded successfully')}`,
            icon: 'success',
          }).then(() => {
            setNamaFile('')
            setDescription('')
            setDataType('')
            setIsPrivate(false)
            setTempRole([])
            setFiles({ file: null })
            clearFile()
          })
          ambilAttachment(subOrderID)
        },
        (err) => {
          setNamaFile('')
          setDescription('')
          setDataType('')
          setFiles({ file: null })
          clearFile()
          swal({
            title: t(err.response.data.message),
            icon: 'error',
          })
        }
      )
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const [estimate, setEstimate] = useState<any>()
  const [estimateTo, setEstimateTo] = useState<any>('')

  const [language, setLanguage] = useState<any>()

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const handleEdit = async () => {
    swal({
      title: `${t('apakahAndaYakin create Contract')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    })
      .then(async (willCreate) => {
        if (willCreate) {
          const payload: any = []
          ordersubdetail.forEach((data: any, _index: any) => {
            payload.push({
              id: payloadID[_index],
              plant: payloadPlantID[_index],
              plant_desc: payloadPlantDesc[_index],
              sloc: payloadSloc[_index],
              sloc_description: payloadSlocDesc[_index],
              product_type: payloadType[_index],
              product_type_desc: payloadDesc[_index],
              product_name: payloadName[_index],
              material_number: payloadMaterial[_index],
              unit: payloadUnit[_index],
              product_spec: payloadSpec[_index],
              fixed_quantum: payloadQuantum[_index],
              fixed_price: payloadHarga[_index],
              province_id: data.province?.id,
              city_id: data.city?.id,
              at_sales_option: data.at_sales_option,
              shipping_tolerance_contract: data?.shipping_tolerance_contract,
              material_desc_en: data?.material_desc_en,
              plant_desc_en: data?.plant_desc_en,
            })
          })
          setBtnLoading(true)
          axios
            .put(
              `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/contract/update-amendment/${details?.id
              }?credentials=${localStorage.getItem('credential')}&lang=${language}`,
              {
                validity_date_from: estimate,
                validity_date_to: estimateTo,
                total_quantum: totalQ,
                total_price: beforePpn,
                grand_total: fixedPrice,
                order_sub_details: payload,
                title: title ? title : '',
                title_en: titleEn ? titleEn : '',
                customer_pic_name: customer_pic_name ? customer_pic_name : '',
                customer_pic_position: customer_pic_position ? customer_pic_position : '',
                terms_and_conditions: terms_and_conditions ? terms_and_conditions : '',
                terms_and_conditions_en: terms_and_conditionsEn ? terms_and_conditionsEn : '',
                mail_body: mail_body ? mail_body : '',
                mail_body_en: mail_bodyEn ? mail_bodyEn : '',
                customer_attn: customer_attn ? customer_attn : '',
                customer_attn_en: customer_attnEn ? customer_attnEn : '',
                port_of_discharge: port_of_discharge ? port_of_discharge : '',
                lain_lain: lain_lain ? lain_lain : '',
                lain_lain_en: lain_lainEn ? lain_lainEn : '',
                keterangan: keterangan ? keterangan : '',
                keterangan_en: keteranganEn ? keteranganEn : '',
                text_penutup: textPenutup ? textPenutup : '',
                text_penutup_en: textPenutupEn ? textPenutupEn : '',
                no_izin_export: noExport ? noExport : '',
                assigner_name: assignerName,
                assigner_position: assignerPos,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                  apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                  Accept: 'application/json',
                  'Access-Control-Allow-Origin': '*',
                },
              }
            )
            .then((response) => {
              if (!response.data.error) {
                swal({
                  title: `${t(response.data.message)}`,
                  icon: 'success',
                }).then(() => {
                  navigate('/management/kontrak')
                })
              }
            })
            .catch((response) => {
              swal({
                title: `${t(response.response.data.message)}`,
                icon: 'error',
              })
            })
            .finally(() => {
              setBtnLoading(false)
            })
        }
      })
      .catch((err) => { })
  }

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  const [loadingSAP, setLoadingSAP] = useState(false)

  const handleSyncSAP = async () => {
    setLoadingSAP(true)
    await syncKontrak({
      lang: i18next.language,
      sap_number: SOSAPNum,
      credentials: localStorage.getItem('credential'),
    })
      .then((res) => {
        swal({
          title: `${t(res.data.message)}`,
          icon: 'success',
        }).then(() => {
          getDetail()
        })
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setLoadingSAP(false)
      })
  }

  const handleShowEndUser = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return <label>{temp}</label>
  }

  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const [showAdditional, setShowAdditional] = useState(false)

  const [title, setTitle] = useState('')
  const [customer_pic_name, setCustomer_pic_name] = useState('')
  const [customer_pic_position, setCustomer_pic_position] = useState('')
  const [terms_and_conditions, setTerms_and_conditions] = useState('')
  const [mail_body, setMail_body] = useState('')
  const [customer_attn, setCustomer_attn] = useState('')
  const [port_of_discharge, setPort_of_discharge] = useState('')
  const [lain_lain, setLain_lain] = useState('')
  const [keterangan, setKeterangan] = useState('')
  const [textPenutup, setTextPenutup] = useState('')
  const [noExport, setNoExport] = useState('')

  const [addTextLanguage, setAddTextLanguage] = useState('id')
  const [titleEn, setTitleEn] = useState('')
  const [mail_bodyEn, setMail_bodyEn] = useState('We hereby convey the purchase agreement with the following details:')
  const [customer_attnEn, setCustomer_attnEn] = useState('')
  const [textPenutupEn, setTextPenutupEn] = useState('')
  const [lain_lainEn, setLain_lainEn] = useState('')
  const [keteranganEn, setKeteranganEn] = useState('')
  const [terms_and_conditionsEn, setTerms_and_conditionsEn] = useState('')

  const [title_, setTitle_] = useState('')
  const [customer_pic_name_, setCustomer_pic_name_] = useState('')
  const [customer_pic_position_, setCustomer_pic_position_] = useState('')
  const [terms_and_conditions_, setTerms_and_conditions_] = useState('')
  const [mail_body_, setMail_body_] = useState('')
  const [customer_attn_, setCustomer_attn_] = useState('')
  const [port_of_discharge_, setPort_of_discharge_] = useState('')
  const [lain_lain_, setLain_lain_] = useState('')
  const [keterangan_, setKeterangan_] = useState('')
  const [textPenutup_, setTextPenutup_] = useState('')
  const [noExport_, setNoExport_] = useState('')
  const [attachmentType, setAttachmentType] = useState('order-item')

  const handleOpenn = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('a')) {
      icon?.classList.remove('a')
      icon?.classList.add('b')
    } else {
      icon?.classList.remove('b')
      icon?.classList.add('a')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('foldd-open')
  }

  const handleSaveAdditionalText = (id: any, state: any, value: any) => {
    state(value)
    let close = document.getElementById('target' + id) as HTMLInputElement
    close?.classList.remove('foldd-open')
    close?.classList.add('fold')
    swal({
      title: `${t('alert-Berhasil') + ' ' + t('order-tambah') + ' ' + t(id)}`,
      icon: 'success',
    })
  }

  const editAdditionalText = async () => {
    setBtnLoading(true)
    const payload = {
      title: title ? title : '',
      title_en: titleEn ? titleEn : '',
      customer_pic_name: customer_pic_name ? customer_pic_name : '',
      customer_pic_position: customer_pic_position ? customer_pic_position : '',
      terms_and_conditions: terms_and_conditions ? terms_and_conditions : '',
      terms_and_conditions_en: terms_and_conditionsEn ? terms_and_conditionsEn : '',
      mail_body: mail_body ? mail_body : '',
      mail_body_en: mail_bodyEn ? mail_bodyEn : '',
      customer_attn: customer_attn ? customer_attn : '',
      customer_attn_en: customer_attnEn ? customer_attnEn : '',
      port_of_discharge: port_of_discharge ? port_of_discharge : '',
      lain_lain: lain_lain ? lain_lain : '',
      lain_lain_en: lain_lainEn ? lain_lainEn : '',
      keterangan: keterangan ? keterangan : '',
      keterangan_en: keteranganEn ? keteranganEn : '',
      text_penutup: textPenutup ? textPenutup : '',
      text_penutup_en: textPenutupEn ? textPenutupEn : '',
      no_izin_export: noExport ? noExport : '',
      assigner_name: assignerName,
      assigner_position: assignerPos,
    }
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
    }).then(async (accept) => {
      if (accept) {
        await resubmitAdditionalText(id, payload).then((res) => {
          setBtnLoading(false)
          swal({
            title: `${t('Data Updated Successfully')}`,
            icon: 'success',
          })
            .then(() => {
              navigate('/management/kontrak')
            })
            .catch((err) => {
              swal({
                title: `${t(err.response.data.message.message)}`,
                icon: 'error',
              }).then(() => {
                setShowAdditional(false)
              })
            })
        })
      }
    })
    setBtnLoading(false)
  }

  CustomUseEffect(() => {
    const getUser = async () => {
      await getUserDetail(sektorid, customerCode).then((res: any) => {
        setUserDetail(res.data.data)
      })
    }

    const getFooter = async () => {
      await getFooterContent(salesOrg, 'contract').then((res: any) => {
        setFooter(res.data.data)
      })
    }

    getFooter()
    getUser()
  }, [details])

  const letterData = {
    lang: i18next.language,
    sector: sektorid ? sektorid : '',
    customer: customerTitle ? customerTitle + ' ' + customerName : customerName,
    anper: details?.order_sub_details
      ? details?.order_sub_details[0]?.produsen?.name ||
      details?.order_sub_details?.sales_org_code_desc
      : '',
    address: userDetail ? userDetail?.address?.street1 : '',
    city: userDetail ? userDetail?.city?.city_name : '',
    region: userDetail ? userDetail?.region?.region_name : '',
    customerAttn: i18next.language == 'id' ? customer_attn : (customer_attnEn || (customer_attn || '')),
    mail: i18next.language == 'id' ? mail_body : (mail_bodyEn || (mail_body || '')),
    terms: i18next.language == 'id' ? terms_and_conditions : (terms_and_conditionsEn || (terms_and_conditions || '')),
    title: i18next.language == 'id' ? title : (titleEn || (title || '')),
    dateFrom: details?.validity_date_from,
    dateTo: details?.validity_date_to,
    port: port_of_discharge ? port_of_discharge : '',
    lain_lain: i18next.language == 'id' ? lain_lain : (lain_lainEn || (lain_lain || '')),
    keterangan: i18next.language == 'id' ? keterangan : (keteranganEn || (keterangan || '')),
    textPenutup: i18next.language == 'id' ? textPenutup : (textPenutupEn || (textPenutup || '')),
    configletter: footer ? (i18next.language == 'id' ? (footer?.indonesia?.content || '') : (footer?.english?.content || '')) : '',
    subItem: details?.order_sub_details ? details?.order_sub_details : [],
    signername: assignerName ? assignerName : '',
    singerposition: assignerPos ? assignerPos : '',
    cusName: customer_pic_name ? customer_pic_name : '',
    cusPos: customer_pic_position ? customer_pic_position : '',
    include: details?.doc_is_inc_ppn,
    payloadharga: payloadHarga ? payloadHarga : '',
    payloadquantum: payloadQuantum ? payloadQuantum : '',
    payloadspec: payloadSpec ? payloadSpec : '',
    imgHeader: imgHeader ? imgHeader?.url_file : '',
    imgFooter: imgFooter ? imgFooter?.url_file : '',
    pph22: PPh22,
    segment: details?.order_sub_details ? details?.order_sub_details[0]?.segment_name : "",
    incoterm1: details?.incoterm?.code,
    incoterm2: details?.incoterm2_id,
    sapNumber: details?.sap_number,
    approvedDate: details?.release_date,
    has_amendment: details?.has_amendment || (details?.sap_number ? details?.is_amendment : false)
  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const handleDownloadDraft = async () => {
    try {
      setLoadingDownloadDraft(true)
      const response = await downloadDraft(ContractID, i18next.language);
      const href = URL.createObjectURL(response.data)

      let file_name = `12${kontrakId}_${customerName}_${(i18next.language == 'en' ? '_Letter_of_Confirmation' : '_SKPP')}`

      if ([1, 2, 3, 99].includes(status)) file_name = file_name + '_DRAFT';

      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', file_name + '.pdf')
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      setLoadingDownloadDraft(false)
    } catch (error) {
      setLoadingDownloadDraft(false)
      swal({
        title: t('Donwload Failed'),
        icon: 'error',
      })
    }
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('MANAGEMENT_CONTRACT_DETAIL.TITLE')}</PageTitle>
      <div className='card'>
        <div className='card-body'>
          {roleUser == 'null' ? (
            <>
              {!loading ? (
                <div>
                  <Row>
                    <Col lg={6}>
                      <Row className='mb-4 mt-4'>
                        <Col lg={5}>
                          <p className='fs-4'>Status</p>
                        </Col>
                        <Col lg={7}>
                          <BadgeColorKontrak
                            text={details?.status_text}
                            status={details?.status}
                            role={roleUser}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-3'>{t('kontrak-nomor')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            placeholder='ID-22912'
                            value={'12' + details?.contract_number}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      {details?.sap_number && <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-3'>{t('SAP Number')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            value={details?.sap_number}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>}
                      <Row className='mb-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control type='text' value={customerCode} disabled size='sm' />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-2'>Incoterm</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            placeholder='Incoterm'
                            value={details?.incoterm1?.code}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-2'>{t('negara')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            value={details?.country_destination}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Sales Office')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            type='text'
                            value={details?.sales_office_detail?.region_name}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      {details?.validity_date_from && (
                        <Row className='mb-3'>
                          <Col lg={5}>
                            <p className='fs-4 mt-2'>{t('order-tanggal-dari')}</p>
                          </Col>
                          <Col lg={7}>
                            <Form.Control
                              type='text'
                              placeholder={t('order-tanggal-dari')}
                              value={dateformat(details.validity_date_from)}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                      )}
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-2'>{t('Assigner Name')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            placeholder={t('Assigner Name')}
                            value={details?.assigner_name}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      {/* <Row className='mb-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('nomorIzinExport')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            type='text'
                            value={details?.no_izin_export}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row> */}
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-2'>{t('Ship To')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            value={customerShip ? customerShip : ''}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <Row className='mb-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Address')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            as='textarea'
                            value={customerAddress}
                            disabled
                            size='sm'
                            style={{ minHeight: '40px', height: 'auto' }}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-3'>{t('sip-number')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            placeholder='SIP-22912'
                            value={
                              details?.sip_order?.SIP_number
                                ? '11' + details?.sip_order?.SIP_number
                                : ''
                            }
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control type='text' value={customerName} disabled size='sm' />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-2'>Incoterm 2</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            placeholder='Incoterm2'
                            value={details?.incoterm2_id}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-2'>{t('provinsi-tujuan')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            placeholder={t('provinsi-tujuan')}
                            value={details?.province_desc}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Sales Group')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            type='text'
                            value={details?.sales_group_detail?.city_name}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-3'>{t('order-tanggal-berakhir')}</p>
                        </Col>
                        <Col lg={7} className='d-flex'>
                          {amandement ? (
                            <>
                              <Form.Control
                                type='date'
                                value={estimateTo}
                                onChange={(e: any) => setEstimateTo(e.target.value)}
                                size='sm'
                              />
                            </>
                          ) : (
                            <>
                              {details?.validity_date_to && (
                                <Form.Control
                                  type='text'
                                  placeholder={t('order-tanggal-berakhir')}
                                  value={dateformat(details?.validity_date_to)}
                                  disabled
                                  size='sm'
                                />
                              )}
                            </>
                          )}
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-2'>{t('Assigner Positions')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            placeholder={t('Assigner Name')}
                            value={details?.assigner_position}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-2'>{t('sub-order-provinsi')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            placeholder={t('sub-order-provinsi')}
                            value={details?.province_desc}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  {/* <div className='d-flex justify-content-start'>
                    <Button
                      onClick={() => {
                        setShowLetter(true)
                      }}
                      className='btn btn-primary fw-semibold d-flex align-items-center ms-2'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('preview')}
                    >
                      {t('preview')}
                    </Button>
                    <Modal
                      show={showLetter}
                      onHide={() => setShowLetter(false)}
                      size='xl'
                      backdrop='static'
                      keyboard={false}
                      scrollable
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>{t('preview')}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <ViewLetter data={letterData} type='kontrak' />
                      </Modal.Body>
                    </Modal>
                  </div> */}

                  <div className='table-responsive mt-5 bdr'>
                    {/* Table Head */}
                    <TableUI.TableDetail colSpan={14}>
                      <TableUI.TableWrapper style={{ marginBottom: 0 }}>
                        <TableUI.Table>
                          <TableUI.THead>
                            <tr style={{ backgroundColor: '#274070' }}>
                              <th>{t('kontrak-item')}</th>
                              <th>Status</th>
                              <th>{t('kontrak-aksi')}</th>
                              <th>Sales Org</th>
                              <th>{t('kontrak-incoterm')} </th>
                              {sektorid == 1 && <th>{t('segment')}</th>}
                              <th>{t('sub-order-endUser')}</th>
                              <th>{t('Sektor')} </th>
                              <th>{t('kontrak-jenis')} </th>
                              <th>{t('Product Code')} </th>
                              <th>{t('kontrak-nama')} </th>
                              <th>{t('kontrak-spek')}</th>
                              <th>{t('sub-order-kuantumD')}</th>
                              <th>{t('Shipping Tolerance')}</th>
                              <th>{t('kontrak-harga')}</th>
                              <th>{t('kontrak-hargaPPN')}</th>
                              <th>{t('kontrak-ppn')}</th>
                              <th>{t('kontrak-hargaSPPN')}</th>
                              {/* <th>Status {t('Price')}</th> */}
                              {/* <th>{t('kontrak-kuantum')}</th> */}
                              {sektorid == 2 ? <th>{t('kontrak-Gudang')} </th> : ''}
                            </tr>
                          </TableUI.THead>
                          <TableUI.TBody>
                            {details != null ? (
                              <>
                                {details?.order_sub_details?.map((detailss: any, index: number) => {
                                  return (
                                    <tr key={detailss?.id ?? index}>
                                      <td>
                                        <div>{index + 1}</div>
                                      </td>
                                      <td>
                                        <BadgeColorKontrak
                                          text={detailss?.status_text_contract}
                                          status={detailss?.status_contract}
                                          role={roleUser}
                                        />
                                      </td>
                                      <td>
                                        <div
                                          className='d-flex justify-content-center'
                                          style={{ marginTop: '-.5px', marginBottom: '-.5px' }}
                                        >
                                          <button
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                            data-bs-toggle='tooltip'
                                            data-bs-placement='top'
                                            data-bs-trigger='hover'
                                            title='Detail'
                                            onClick={() => handleDetail(detailss)}
                                          >
                                            <KTSVG
                                              path='/media/icons/duotune/file-text-fill.svg'
                                              className='svg-icon-3'
                                            />
                                          </button>
                                          <button
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                            data-bs-toggle='tooltip'
                                            data-bs-placement='top'
                                            data-bs-trigger='hover'
                                            title={t('order-lampiran')}
                                            onClick={() => {
                                              setFileBox(detailss)
                                              setSubOrderID(detailss?.order_sub_item_id ?? detailss?.id)
                                              ambilAttachment(detailss?.order_sub_item_id ?? detailss?.id, 'order-item')
                                            }}
                                          >
                                            <KTSVG
                                              path='/media/icons/duotune/archive-fill.svg'
                                              className='svg-icon-3'
                                            />
                                          </button>
                                        </div>
                                      </td>
                                      <td>
                                        <div>{detailss.produsen.name}</div>
                                      </td>
                                      {detailss.incoterm2 != null ? (
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={
                                                detailss.incoterm1.code +
                                                '-' +
                                                detailss.incoterm2.code
                                              }
                                              index={index}
                                              className='spec-sliceee'
                                            />
                                          </div>
                                        </td>
                                      ) : (
                                        <>
                                          {detailss.incoterm2_id == null ||
                                            detailss.incoterm2_id == '0' ? (
                                            <td>
                                              <div>{detailss.incoterm1.code}</div>
                                            </td>
                                          ) : (
                                            <td>
                                              <div>
                                                <PopoverText
                                                  content={
                                                    detailss.incoterm1.code +
                                                    '-' +
                                                    detailss.incoterm2_id
                                                  }
                                                  index={index}
                                                  className='spec-sliceee'
                                                />
                                              </div>
                                            </td>
                                          )}
                                        </>
                                      )}
                                      {sektorid == 1 && (
                                        <td>
                                          <div>{t(detailss.segment_name)}</div>
                                        </td>
                                      )}
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={detailss.end_user}
                                            index={index}
                                            className='desc-slicee'
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>{t(detailss?.sector?.name)}</div>
                                      </td>
                                      <td>
                                        <div>{detailss?.product_type_desc}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {parseInt(detailss.material_number) == 0
                                            ? ''
                                            : detailss.material_number?.slice(-7)}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{detailss.product_name}</div>
                                      </td>
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={detailss.product_spec || '-'}
                                            index={index}
                                            className='spec-sliceee'
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          {i18next.language === 'en'
                                            ? detailss.quantum_contract?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                            : detailss.quantum_contract?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })}{' '}
                                          {detailss?.product_type_desc == 'KANTONG/SACK'
                                            ? detailss?.unit
                                            : detailss.sector_id === 3
                                              ? 'MT'
                                              : 'Ton'}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{detailss.shipping_tolerance_contract}%</div>
                                      </td>
                                      {/* <td>
                                {detailss.request_price.toLocaleString()}/1
                              </td> */}
                                      <td>
                                        <div>
                                          {i18next.language === 'en'
                                            ? detailss.price_contract?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                            : detailss.price_contract?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })}
                                          /
                                          {detailss?.product_type_desc == 'KANTONG/SACK'
                                            ? detailss?.unit
                                            : detailss.sector_id === 3
                                              ? 'MT'
                                              : 'Ton'}
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          {(detailss?.sector_id != 3 ? 'Rp ' : 'USD ') +
                                            (i18next.language === 'en'
                                              ? detailss.price_before_ppn?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                              : detailss.price_before_ppn?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }))}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{detailss.ppn}%</div>
                                      </td>
                                      <td>
                                        <div>
                                          {(detailss?.sector_id != 3 ? 'Rp ' : 'USD ') +
                                            (i18next.language === 'en'
                                              ? detailss.price_after_ppn?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                              : detailss.price_after_ppn?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }))}
                                        </div>
                                      </td>
                                      {/* <td className='td-order-2 text-center column ms-2'>
                                {detailss.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                              </td> */}
                                      {detailss?.sector_id == 2 ? (
                                        <td>
                                          <div>{detailss?.plant_desc}</div>
                                        </td>
                                      ) : (
                                        ''
                                      )}
                                    </tr>
                                  )
                                })}
                              </>
                            ) : null}
                          </TableUI.TBody>
                        </TableUI.Table>
                      </TableUI.TableWrapper>
                    </TableUI.TableDetail>
                    {/* End Table Head */}
                  </div>

                  <div style={{ width: '50%' }}>
                    <Row className='mb-3'>
                      <Col lg={5}>
                        <p className='fs-4 mt-3'>Total {t('kontrak-kuantum')}</p>
                      </Col>
                      <Col lg={7}>
                        {details != null ? (
                          <Form.Control
                            type='text'
                            placeholder={'Total ' + t('kontrak-kuantum')}
                            value={
                              (i18next.language === 'en'
                                ? quantumApprove.toLocaleString('en', { maximumFractionDigits: 4 })
                                : quantumApprove.toLocaleString('id', { maximumFractionDigits: 4 })) +
                              ' ' +
                              'Ton'
                            }
                            disabled
                          />
                        ) : (
                          <Form.Control
                            type='text'
                            placeholder={'Total ' + t('kontrak-kuantum')}
                            disabled
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-3' hidden={kantongApprove != 0 ? false : true}>
                      <Col lg={5}>
                        <p className='fs-4 mt-3'>Total {t('sack')}</p>
                      </Col>
                      <Col lg={7}>
                        {details != null ? (
                          <Form.Control
                            type='text'
                            placeholder={'Total ' + t('sack')}
                            value={
                              (i18next.language === 'en'
                                ? kantongApprove.toLocaleString('en', { maximumFractionDigits: 4 })
                                : kantongApprove.toLocaleString('id', { maximumFractionDigits: 4 })) +
                              ' ' +
                              kantongUnit
                            }
                            disabled
                          />
                        ) : (
                          <Form.Control type='text' placeholder={'Total ' + t('sack')} disabled />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col lg={5}>
                        <p className='fs-4 mt-3'>Total {t('Exclude')} PPN</p>
                      </Col>
                      <Col lg={7}>
                        {details != null ? (
                          <Form.Control
                            type='text'
                            placeholder={'Total ' + t('Exclude') + ' PPN'}
                            value={
                              (details?.order_sub_details[0].sector_id != 3 ? 'Rp ' : 'USD ') +
                              (i18next.language === 'en'
                                ? BeforePPNKontrak(
                                  details?.order_sub_details,
                                  payloadQuantum,
                                  payloadHarga
                                ).toLocaleString('en', { maximumFractionDigits: 4 })
                                : BeforePPNKontrak(
                                  details?.order_sub_details,
                                  payloadQuantum,
                                  payloadHarga
                                ).toLocaleString('id', { maximumFractionDigits: 4 }))
                            }
                            disabled
                          />
                        ) : (
                          <Form.Control type='text' placeholder={t('Exclude')} disabled />
                        )}
                      </Col>
                    </Row>

                    <Row className='mb-3'>
                      <Col lg={5}>
                        <p className='fs-4 mt-3 mt-3'>Total {t('Include')} PPN</p>
                      </Col>
                      <Col lg={7}>
                        {details != null ? (
                          <Form.Control
                            type='text'
                            placeholder={'Total ' + t('Include') + ' PPN'}
                            value={
                              (details?.order_sub_details[0].sector_id != 3 ? 'Rp ' : 'USD ') +
                              (i18next.language === 'en'
                                ? AfterPPNKontrak(
                                  details?.order_sub_details,
                                  payloadQuantum,
                                  payloadHarga
                                ).toLocaleString('en', { maximumFractionDigits: 4 })
                                : AfterPPNKontrak(
                                  details?.order_sub_details,
                                  payloadQuantum,
                                  payloadHarga
                                ).toLocaleString('id', { maximumFractionDigits: 4 }))
                            }
                            disabled
                          />
                        ) : (
                          <Form.Control type='text' placeholder={t('grandtotal')} disabled />
                        )}
                      </Col>
                    </Row>
                  </div>

                  <div className='d-flex justify-content-end'>
                    <Link to={'/management/kontrak'}>
                      <button className='btn btn-secondary'>{t('Back')}</button>
                    </Link>
                  </div>
                </div>
              ) : (
                <div className='d-flex justify-content-center py-10'>
                  <div className='lds-ellipsis'>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              {!loading ? (
                <div style={{ marginTop: '2rem' }}>
                  {/* begin::Header */}

                  <Row>
                    <Col lg={6}>
                      <Row className='mb-4 mt-4'>
                        <Col lg={5}>
                          <p className='fs-4'>Status</p>
                        </Col>
                        <Col lg={7}>
                          <BadgeColorKontrak
                            text={details?.status_text}
                            status={details?.status}
                            role={roleUser}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-3'>{t('kontrak-kontrakID')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            placeholder='ID-22912'
                            value={'12' + details?.contract_number}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control type='text' value={customerCode} disabled size='sm' />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-2'>Incoterm</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            placeholder='Incoterm'
                            value={details?.incoterm1?.code}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-2'>{t('negara')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            value={details?.country_destination}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>Sales Office</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            type='text'
                            value={details?.sales_office_detail?.region_name}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      {details?.validity_date_from && (
                        <Row className='mb-3'>
                          <Col lg={5}>
                            <p className='fs-4 mt-2'>{t('order-tanggal-dari')}</p>
                          </Col>
                          <Col lg={7}>
                            <Form.Control
                              type='text'
                              placeholder={t('order-tanggal-dari')}
                              value={dateformat(details.validity_date_from)}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                      )}
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-2'>{t('Assigner Name')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            placeholder={t('Assigner Name')}
                            defaultValue={assignerName}
                            onChange={(e) => setassignerName(e.target.value)}
                            disabled={(SOSAPNum != null || amandement) && ['salesAnper', 'admin'].includes(roleUser) ? false : true}
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-2'>{t('Ship To')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            value={customerShip ? customerShip : ''}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <Row className='mb-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Address')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            as='textarea'
                            value={customerAddress}
                            disabled
                            size='sm'
                            style={{ height: '40px' }}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-3'>{t('sip-number')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            placeholder='SIP-22912'
                            value={
                              details?.sip_order?.SIP_number
                                ? '11' + details?.sip_order?.SIP_number
                                : ''
                            }
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control type='text' value={customerName} disabled size='sm' />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-2'>Incoterm 2</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            placeholder='Incoterm2'
                            value={details?.incoterm2_id}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-2'>{t('provinsi-tujuan')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            value={details?.province_desc}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>Sales Group</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            type='text'
                            value={details?.sales_group_detail?.city_name}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-3'>{t('order-tanggal-berakhir')}</p>
                        </Col>
                        <Col lg={7} className='d-flex'>
                          {amandement ? (
                            <>
                              <Form.Control
                                type='date'
                                value={estimateTo}
                                onChange={(e: any) => setEstimateTo(e.target.value)}
                                size='sm'
                              />
                            </>
                          ) : (
                            <>
                              {details?.validity_date_to && (
                                <Form.Control
                                  type='text'
                                  placeholder={t('order-tanggal-berakhir')}
                                  value={dateformat(details.validity_date_to)}
                                  disabled
                                  size='sm'
                                />
                              )}
                            </>
                          )}
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-2'>{t('Assigner Position')}</p>
                        </Col>
                        <Col lg={7}>
                          <Form.Control
                            type='text'
                            placeholder={t('Assigner Position')}
                            defaultValue={assignerPos}
                            onChange={(e) => setassignerPos(e.target.value)}
                            disabled={(SOSAPNum != null || amandement) && ['salesAnper', 'admin'].includes(roleUser) ? false : true}
                            size='sm'
                          />
                        </Col>
                      </Row>
                      {/* <Row className='mb-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('nomorIzinExport')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            type='text'
                            value={details?.no_izin_export}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row> */}
                    </Col>
                  </Row>

                  <hr />

                  <div className='d-flex justify-content-end mt-6 mb-2'>
                    <button
                      hidden={SOSAPNum != null ? false : true}
                      className='btn btn-primary me-2'
                      onClick={() => handleSyncSAP()}
                      disabled={loadingSAP}
                    >
                      {loadingSAP ? (
                        <>
                          <Spinner animation='border' size='sm' />
                        </>
                      ) : (
                        <>
                          <i className="bi bi-arrow-repeat"></i>
                          {t('Sync SAP')}
                        </>
                      )}
                    </button>

                    <Button
                      className='ms-2'
                      variant='primary'
                      onClick={() => {
                        setAttachmentType('contract')
                        setSubOrderID(ContractID || '')
                        ambilAttachment(ContractID, 'contract')
                        setDownloadOnly(false)
                      }}
                    >
                      <i className="bi bi-file-earmark-text"></i>
                      {t('order-lampiran')}
                    </Button>

                    <button
                      className='btn btn-primary ms-2'
                      disabled={(SOSAPNum != null || amandement) && ['salesAnper', 'admin'].includes(roleUser) ? false : true}
                      onClick={() => setShowAdditional(true)}
                    >
                      {t('addtional')} {t('text')}
                    </button>
                    <Modal
                      show={showAdditional}
                      onHide={() => setShowAdditional(false)}
                      size='lg'
                      centered
                      backdrop='static'
                      keyboard={false}
                      scrollable
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>
                          {t('addtional')} {t('text')}
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>

                        <div className="d-flex justify-content-end mb-3">
                          <div style={{ maxWidth: 140 }} className='btn-lang d-flex'>
                            <button
                              className={'d-flex align-items-center me-1 ' + (addTextLanguage == 'id' ? 'active' : '')}
                              onClick={() => setAddTextLanguage('id')}
                            >
                              <h6 className='ms-1'>Ind</h6>
                            </button>
                            <button
                              className={'d-flex align-items-center me-1 ' + (addTextLanguage == 'en' ? 'active' : '')}
                              onClick={() => setAddTextLanguage('en')}
                            >
                              <h6 className='ms-1'>Eng</h6>
                            </button>
                          </div>
                        </div>


                        {addTextLanguage == 'id' && <div>
                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'Judul'}
                                onClick={handleOpenn}
                                id='titlee'
                              >
                                <div className='text-light'>{t('Judul')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'Judul'}>
                              <Form.Control
                                className='mt-3'
                                aria-label='Default select example'
                                onChange={(e: any) => setTitle(e.target.value)}
                                placeholder={t('Judul')}
                                defaultValue={title}
                              />
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('Judul', setTitle, title_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'nama'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('customer pic name')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'nama'}>
                              <Form.Control
                                className='mt-3'
                                aria-label='Default select example'
                                onChange={(e: any) => setCustomer_pic_name(e.target.value)}
                                placeholder={t('customer pic name')}
                                defaultValue={customer_pic_name}
                              />
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('nama', setCustomer_pic_name, customer_pic_name_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'Position'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('customer pic position')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'Position'}>
                              <RichText
                                containerClassName='mt-4'
                                content={customer_pic_position}
                                onUpdate={({ editor }) => {
                                  setCustomer_pic_position(editor.getHTML())
                                }}
                              >
                                &nbsp;
                              </RichText>
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('Position', setCustomer_pic_position, customer_pic_position_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'terms_and_conditions'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('terms_and_conditions')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'terms_and_conditions'}>
                              <RichText
                                containerClassName='mt-4'
                                content={terms_and_conditions}
                                onUpdate={({ editor }) => {
                                  setTerms_and_conditions(editor.getHTML())
                                }}
                              >
                                &nbsp;
                              </RichText>
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('terms_and_conditions', setTerms_and_conditions, terms_and_conditions_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'mail_body'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('mail_body')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'mail_body'}>
                              <RichText
                                containerClassName='mt-4'
                                content={mail_body}
                                onUpdate={({ editor }) => {
                                  setMail_body(editor.getHTML())
                                }}
                              >
                                &nbsp;
                              </RichText>
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('mail_body', setMail_body, mail_body_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'customer_attn'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('customer_attn')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'customer_attn'}>
                              <Form.Control
                                className='mt-3'
                                aria-label='Default select example'
                                onChange={(e: any) => setCustomer_attn(e.target.value)}
                                placeholder={t('customer_attn')}
                                defaultValue={customer_attn}
                              />
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer_attn', setCustomer_attn, customer_attn_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'port_of_discharge'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('Tujuan')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'port_of_discharge'}>
                              <Form.Control
                                className='mt-3'
                                aria-label='Default select example'
                                onChange={(e: any) => setPort_of_discharge(e.target.value)}
                                placeholder={t('Tujuan')}
                                defaultValue={port_of_discharge}
                              />
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('port_of_discharge', setPort_of_discharge, port_of_discharge_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'other'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('other')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'other'}>
                              <RichText
                                containerClassName='mt-4'
                                content={lain_lain}
                                onUpdate={({ editor }) => {
                                  setLain_lain(editor.getHTML())
                                }}
                              >
                                &nbsp;
                              </RichText>
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('other', setLain_lain, lain_lain_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'order-keterangan'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('order-keterangan')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'order-keterangan'}>
                              <RichText
                                containerClassName='mt-4'
                                content={keterangan}
                                onUpdate={({ editor }) => {
                                  setKeterangan(editor.getHTML())
                                }}
                              >
                                &nbsp;
                              </RichText>
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('order-keterangan', setKeterangan, keterangan_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'textPenutup'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('textPenutup')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'textPenutup'}>
                              <RichText
                                containerClassName='mt-4'
                                content={textPenutup}
                                onUpdate={({ editor }) => {
                                  setTextPenutup(editor.getHTML())
                                }}
                              >
                                &nbsp;
                              </RichText>
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('textPenutup', setTextPenutup, textPenutup_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'nomor export'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('nomorIzinExport')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'nomor export'}>
                              <Form.Control
                                className='mt-3'
                                as='textarea'
                                //maxLength={132}
                                aria-label='Default select example'
                                onChange={(e: any) => setNoExport(e.target.value)}
                                placeholder={t('nomorIzinExport')}
                                defaultValue={noExport}
                              />
                              {/* <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('nomor export', setNoExport, noExport_)}>{t('Save')}</button>
                        </div> */}
                            </div>
                          </Form.Group>
                          <hr />
                        </div>}
                        {addTextLanguage == 'en' && <div>
                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'Judul'}
                                onClick={handleOpenn}
                                id='titlee'
                              >
                                <div className='text-light'>{t('Judul')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'Judul'}>
                              <Form.Control
                                className='mt-3'
                                aria-label='Default select example'
                                onChange={(e: any) => setTitleEn(e.target.value)}
                                placeholder={t('Judul')}
                                defaultValue={titleEn}
                              />
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('Judul', setTitle, title_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'terms_and_conditions'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('terms_and_conditions')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'terms_and_conditions'}>
                              <RichText
                                containerClassName='mt-4'
                                content={terms_and_conditionsEn}
                                onUpdate={({ editor }) => {
                                  setTerms_and_conditionsEn(editor.getHTML())
                                }}
                              >
                                &nbsp;
                              </RichText>
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('terms_and_conditions', setTerms_and_conditions, terms_and_conditions_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'mail_body'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('mail_body')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'mail_body'}>
                              <RichText
                                containerClassName='mt-4'
                                content={mail_bodyEn}
                                onUpdate={({ editor }) => {
                                  setMail_bodyEn(editor.getHTML())
                                }}
                              >
                                &nbsp;
                              </RichText>
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('mail_body', setMail_body, mail_body_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'customer_attn'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('customer_attn')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'customer_attn'}>
                              <Form.Control
                                className='mt-3'
                                aria-label='Default select example'
                                onChange={(e: any) => setCustomer_attnEn(e.target.value)}
                                placeholder={t('customer_attn')}
                                defaultValue={customer_attnEn}
                              />
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer_attn', setCustomer_attn, customer_attn_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'other'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('other')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'other'}>
                              <RichText
                                containerClassName='mt-4'
                                content={lain_lainEn}
                                onUpdate={({ editor }) => {
                                  setLain_lainEn(editor.getHTML())
                                }}
                              >
                                &nbsp;
                              </RichText>
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('other', setLain_lain, lain_lain_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'order-keterangan'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('order-keterangan')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'order-keterangan'}>
                              <RichText
                                containerClassName='mt-4'
                                content={keteranganEn}
                                onUpdate={({ editor }) => {
                                  setKeteranganEn(editor.getHTML())
                                }}
                              >
                                &nbsp;
                              </RichText>
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('order-keterangan', setKeterangan, keterangan_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'textPenutup'}
                                onClick={handleOpenn}
                              >
                                <div className='text-light'>{t('textPenutup')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'textPenutup'}>
                              <RichText
                                containerClassName='mt-4'
                                content={textPenutupEn}
                                onUpdate={({ editor }) => {
                                  setTextPenutupEn(editor.getHTML())
                                }}
                              >
                                &nbsp;
                              </RichText>
                              {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('textPenutup', setTextPenutup, textPenutup_)}>
                          {t('Save')}
                        </button>
                      </div> */}
                            </div>
                          </Form.Group>
                          <hr />
                        </div>}

                        <div className='d-flex justify-content-end mt-5'></div>
                      </Modal.Body>
                    </Modal>

                    <Button
                      onClick={() => {
                        setShowLetter(true)
                      }}
                      className='btn btn-primary fw-semibold d-flex align-items-center ms-2'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('preview')}
                    >
                      <i className='fa fa-eye'></i>
                      {t('preview')}
                    </Button>
                    <Modal
                      show={showLetter}
                      onHide={() => setShowLetter(false)}
                      size='xl'
                      backdrop='static'
                      keyboard={false}
                      scrollable
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>{t('preview')}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <ViewLetter data={letterData} type='kontrak' />
                      </Modal.Body>
                    </Modal>

                    <Button
                      disabled={loadingDownloadDraft}
                      variant='primary'
                      className='ms-2'
                      onClick={handleDownloadDraft}
                    >
                      {
                        loadingDownloadDraft ? <i className='fa fa-spin fa-spinner'></i> : <>
                          <i className='fa fa-download'></i>
                          {[1, 2, 3, 99].includes(status) ? t('download-sip') : t('download-skpp')}
                        </>
                      }
                    </Button>
                  </div>

                  <div className='table-responsive mt-2 bdr' style={{ marginBottom: '3rem' }}>
                    {/* Table Head */}
                    <TableUI.TableDetail colSpan={14}>
                      <TableUI.TableWrapper style={{ marginBottom: 0 }}>
                        <TableUI.Table>
                          <TableUI.THead>
                            <tr style={{ backgroundColor: '#274070' }}>
                              <th>{t('kontrak-item')}</th>
                              <th>Status</th>
                              <th>{t('kontrak-aksi')}</th>
                              <th>Sales Org</th>
                              <th>{t('kontrak-incoterm')} </th>
                              <th>{t('kontrak-wilayah')}</th>
                              {sektorid == 1 && <th>{t('segment')}</th>}
                              <th>{t('sub-order-endUser')}</th>
                              <th>{t('Sektor')} </th>
                              <th>{t('kontrak-jenis')} </th>
                              <th>{t('Product Code')} </th>
                              <th>{t('kontrak-nama')} </th>
                              <th>{t('kontrak-spek')}</th>
                              <th>{t('sub-order-kuantumD')}</th>
                              <th>{t('Shipping Tolerance')}</th>
                              <th>{t('kontrak-harga')}</th>
                              {/* <th>Price</th> */}
                              <th>{t('kontrak-hargaPPN')}</th>
                              <th>{t('kontrak-ppn')}</th>
                              <th>{t('kontrak-hargaSPPN')}</th>
                              {/* <th>Status {t('Price')}</th> */}
                              {sektorid == 2 ? <th>{t('kontrak-Gudang')} </th> : ''}
                            </tr>
                          </TableUI.THead>
                          <TableUI.TBody>
                            {details != null ? (
                              <>
                                {ordersubdetail?.map((detailss: any, _index: number) => {
                                  return (
                                    <tr key={detailss?.id ?? _index}>
                                      <td>
                                        <div>{_index + 1}</div>
                                      </td>
                                      <td>
                                        <BadgeColorKontrak
                                          text={detailss?.status_text_contract}
                                          status={detailss?.status_contract}
                                          role={roleUser}
                                        />
                                      </td>
                                      <td>
                                        <div>
                                          <button
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                            data-bs-toggle='tooltip'
                                            data-bs-placement='top'
                                            data-bs-trigger='hover'
                                            title='Detail'
                                            onClick={() => handleDetail(detailss)}
                                          >
                                            <KTSVG
                                              path='/media/icons/duotune/file-text-fill.svg'
                                              className='svg-icon-3'
                                            />
                                          </button>

                                          <button
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                            data-bs-toggle='tooltip'
                                            data-bs-placement='top'
                                            data-bs-trigger='hover'
                                            title={t('order-lampiran')}
                                            onClick={() => {
                                              setFileBox(detailss)
                                              setSubOrderID(detailss?.order_sub_item_id ?? detailss?.id)
                                              ambilAttachment(detailss?.order_sub_item_id ?? detailss?.id, 'order-item')
                                              roleUser == 'admin'
                                                ? setDownloadOnly(true)
                                                : setDownloadOnly(false)
                                            }}
                                          >
                                            <KTSVG
                                              path='/media/icons/duotune/archive-fill.svg'
                                              className='svg-icon-3'
                                            />
                                          </button>

                                          <button
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                            data-bs-toggle='tooltip'
                                            data-bs-placement='top'
                                            data-bs-trigger='hover'
                                            title={t('Jadwal')}
                                            onClick={() => {
                                              setIDSector(detailss.sector_id)
                                              setProvinceName(detailss.province?.region_name)
                                              setCityName(detailss.city?.city_name)
                                              setProductName(detailss.product_name)
                                              formattingTon(detailss.quantum_contract)
                                              setJadwalID(
                                                detailss?.order_sub_item_id == null
                                                  ? detailss?.id
                                                  : detailss?.order_sub_item_id
                                              )
                                              setShowJadwal(true)
                                              setPtype(detailss.product_type)
                                              setPunit(detailss.unit)
                                            }}
                                          >
                                            <KTSVG
                                              path='/media/icons/duotune/calendar-check-fill.svg'
                                              className='svg-icon-3'
                                            />
                                          </button>
                                          {detailss?.is_amandement_contract && (
                                            <button
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1'
                                              data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title={t('Edit')}
                                              onClick={() => {
                                                setKontrakDetail(detailss)
                                                handleOsd(
                                                  detailss?.sales_org_code,
                                                  payloadMaterial[_index],
                                                  payloadPlantID[_index],
                                                  payloadType[_index]
                                                )
                                                setTempIndex(_index)
                                                setIdItemEdit(detailss?.id)
                                                setPlantEdit(payloadPlantID[_index])
                                                setPlantDescEdit(payloadPlantDesc[_index])
                                                setSlocEdit(payloadSloc[_index])
                                                setSlocDescEdit(payloadSlocDesc[_index])
                                                setMatgroup(payloadType[_index])
                                                setMatgroudesc(payloadDesc[_index])
                                                setMatNumber(payloadMaterial[_index])
                                                setMatUnit(payloadUnit[_index])
                                                setMatDesc(payloadName[_index])
                                                setFq(detailss?.quantum_contract)
                                                setSpec(payloadSpec[_index])
                                                setQuantumEdit(payloadQuantum[_index])
                                                setHargaEdit(payloadHarga[_index])
                                                setPlantt(
                                                  detailss.plant + '~#~' + detailss.plant_desc
                                                )
                                                setIDSector(detailss.sector_id)
                                                setPlantNameEn(detailss.plant_desc_en)
                                                setProductNameEn(detailss.material_desc_en)
                                              }}
                                            >
                                              <KTSVG
                                                path='/media/icons/duotune/pencil-fill.svg'
                                                className='svg-icon-3'
                                              />
                                            </button>
                                          )}

                                          {details?.status == 99 && (
                                            <button
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1'
                                              data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title={t('alasan-tolak')}
                                              onClick={() => {
                                                setShow2(true)
                                              }}
                                            >
                                              <KTSVG
                                                path='/media/icons/duotune/chat-left-text-fill.svg'
                                                className='svg-icon-3'
                                              />
                                            </button>
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{detailss.produsen.name}</div>
                                      </td>
                                      {detailss.incoterm2 != null ? (
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={
                                                detailss.incoterm1.code +
                                                '-' +
                                                detailss.incoterm2.code
                                              }
                                              index={_index}
                                              className='spec-sliceee'
                                            />
                                          </div>
                                        </td>
                                      ) : (
                                        <>
                                          {detailss?.incoterm2_id == null ||
                                            detailss?.incoterm2_id == '0' ? (
                                            <td>
                                              <div>{detailss?.incoterm1.code}</div>
                                            </td>
                                          ) : (
                                            <td>
                                              <div>
                                                <PopoverText
                                                  content={
                                                    detailss.incoterm1.code +
                                                    '-' +
                                                    detailss.incoterm2_id
                                                  }
                                                  index={_index}
                                                  className='spec-sliceee'
                                                />
                                              </div>
                                            </td>
                                          )}
                                        </>
                                      )}
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={
                                              detailss?.province?.region_name ||
                                              '' +
                                              (detailss?.city?.city_name
                                                ? ', ' + detailss?.city?.city_name
                                                : '')
                                            }
                                            index={_index}
                                            className='spec-sliceee'
                                          />
                                        </div>
                                      </td>
                                      {sektorid == 1 && (
                                        <td>
                                          <div>{t(detailss?.segment_name)}</div>
                                        </td>
                                      )}
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={detailss.end_user}
                                            index={_index}
                                            className='desc-slicee'
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>{t(detailss?.sector?.name)}</div>
                                      </td>
                                      <td>
                                        <div>{detailss?.product_type_desc}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {parseInt(detailss.material_number) == 0
                                            ? ''
                                            : detailss.material_number?.slice(-7)}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{detailss.product_name}</div>
                                      </td>
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={detailss.product_spec || '-'}
                                            index={_index}
                                            className='spec-sliceee'
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          {i18next.language === 'en'
                                            ? (
                                              detailss.fixed_quantum_edit ||
                                              detailss.quantum_contract
                                            )?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                            : (
                                              detailss.fixed_quantum_edit ||
                                              detailss.quantum_contract
                                            )?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })}{' '}
                                          {detailss?.product_type_desc == 'KANTONG/SACK'
                                            ? detailss?.unit
                                            : detailss.sector_id === 3
                                              ? 'MT'
                                              : 'Ton'}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{detailss?.shipping_tolerance_contract}%</div>
                                      </td>
                                      {/* <td>
                                {detailss.request_price.toLocaleString()}/1
                              </td> */}
                                      <td>
                                        <div>
                                          {(sektorid != 3 ? 'Rp ' : 'USD ') +
                                            (i18next.language === 'en'
                                              ? payloadHarga[_index]?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                              : payloadHarga[_index]?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }))}
                                          /
                                          {detailss?.product_type_desc == 'KANTONG/SACK'
                                            ? detailss?.unit
                                            : sektorid != 3
                                              ? 'Ton'
                                              : 'MT'}
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          {(sektorid != 3 ? 'Rp ' : 'USD ') +
                                            (i18next.language === 'en'
                                              ? (
                                                payloadQuantum[_index] * payloadHarga[_index]
                                              )?.toLocaleString('en', { maximumFractionDigits: 4 })
                                              : (
                                                payloadQuantum[_index] * payloadHarga[_index]
                                              )?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }))}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{detailss.ppn}%</div>
                                      </td>
                                      <td>
                                        <div>
                                          {(sektorid != 3 ? 'Rp ' : 'USD ') +
                                            (i18next.language === 'en'
                                              ? (
                                                payloadQuantum[_index] *
                                                (payloadHarga[_index] +
                                                  (payloadHarga[_index] / 100) * detailss.ppn) -
                                                ((payloadQuantum[_index] *
                                                  (payloadHarga[_index] +
                                                    (payloadHarga[_index] / 100) *
                                                    detailss.ppn)) /
                                                  ((detailss.ppn + 100) / 100) /
                                                  100) *
                                                0
                                              ).toLocaleString('en', { maximumFractionDigits: 4 })
                                              : (
                                                payloadQuantum[_index] *
                                                (payloadHarga[_index] +
                                                  (payloadHarga[_index] / 100) * detailss.ppn) -
                                                ((payloadQuantum[_index] *
                                                  (payloadHarga[_index] +
                                                    (payloadHarga[_index] / 100) *
                                                    detailss.ppn)) /
                                                  ((detailss.ppn + 100) / 100) /
                                                  100) *
                                                0
                                              ).toLocaleString('id', { maximumFractionDigits: 4 }))}
                                        </div>
                                      </td>
                                      {detailss?.sector_id == 2 ? (
                                        <td>
                                          <div>{detailss?.plant_desc}</div>
                                        </td>
                                      ) : (
                                        ''
                                      )}
                                    </tr>
                                  )
                                })}
                              </>
                            ) : null}
                          </TableUI.TBody>
                        </TableUI.Table>
                      </TableUI.TableWrapper>
                    </TableUI.TableDetail>
                    {/* End Table Head */}
                  </div>

                  <div style={{ width: '50%' }}>
                    <Row className='mb-3'>
                      <Col lg={5}>
                        <p className='fs-4 mt-3'>Total {t('kontrak-kuantum')}</p>
                      </Col>
                      <Col lg={7}>
                        {details != null ? (
                          <Form.Control
                            type='text'
                            placeholder={'Total ' + t('kontrak-kuantum')}
                            value={
                              (i18next.language === 'en'
                                ? quantumApprove.toLocaleString('en', { maximumFractionDigits: 4 })
                                : quantumApprove.toLocaleString('id', { maximumFractionDigits: 4 })) +
                              ' ' +
                              'Ton'
                            }
                            disabled
                          />
                        ) : (
                          <Form.Control
                            type='text'
                            placeholder={'Total ' + t('kontrak-kuantum')}
                            disabled
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-3' hidden={kantongApprove != 0 ? false : true}>
                      <Col lg={5}>
                        <p className='fs-4 mt-3'>Total {t('sack')}</p>
                      </Col>
                      <Col lg={7}>
                        {details != null ? (
                          <Form.Control
                            type='text'
                            placeholder={'Total ' + t('sack')}
                            value={
                              (i18next.language === 'en'
                                ? kantongApprove.toLocaleString('en', { maximumFractionDigits: 4 })
                                : kantongApprove.toLocaleString('id', { maximumFractionDigits: 4 })) +
                              ' ' +
                              kantongUnit
                            }
                            disabled
                          />
                        ) : (
                          <Form.Control type='text' placeholder={'Total ' + t('sack')} disabled />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col lg={5}>
                        <p className='fs-4 mt-3'>Total {t('Exclude')} PPN</p>
                      </Col>
                      <Col lg={7}>
                        {details != null ? (
                          <Form.Control
                            type='text'
                            placeholder={'Total ' + t('Exclude') + ' PPN'}
                            value={
                              (sektorid != 3 ? 'Rp ' : 'USD ') +
                              (i18next.language === 'en'
                                ? BeforePPNKontrak(
                                  details?.order_sub_details,
                                  payloadQuantum,
                                  payloadHarga
                                ).toLocaleString('en', { maximumFractionDigits: 0 })
                                : BeforePPNKontrak(
                                  details?.order_sub_details,
                                  payloadQuantum,
                                  payloadHarga
                                ).toLocaleString('id', { maximumFractionDigits: 0 }))
                            }
                            disabled
                          />
                        ) : (
                          <Form.Control
                            type='text'
                            placeholder={'Total ' + t('Exclude') + ' PPN'}
                            disabled
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col lg={5}>
                        <p className='fs-4 mt-3'>Total {t('Include')} PPN</p>
                      </Col>
                      <Col lg={7}>
                        {details != null ? (
                          <Form.Control
                            type='text'
                            placeholder={'Total ' + t('Include') + ' PPN'}
                            value={
                              (sektorid != 3 ? 'Rp ' : 'USD ') +
                              (i18next.language === 'en'
                                ? AfterPPNKontrak(
                                  details?.order_sub_details,
                                  payloadQuantum,
                                  payloadHarga
                                ).toLocaleString('en', { maximumFractionDigits: 0 })
                                : AfterPPNKontrak(
                                  details?.order_sub_details,
                                  payloadQuantum,
                                  payloadHarga
                                ).toLocaleString('id', { maximumFractionDigits: 0 }))
                            }
                            disabled
                          />
                        ) : (
                          <Form.Control
                            type='text'
                            placeholder={'Total ' + t('Include') + ' PPN'}
                            disabled
                          />
                        )}
                      </Col>
                    </Row>
                  </div>

                  <div className='d-flex justify-content-end flex-column flex-md-row mt-8 '>
                    <div className='mb-3 mb-md-0 d-flex justify-content-end'>
                      {amandement ? (
                        <>
                          <Link to={'/management/kontrak'}>
                            <Button className='btn btn-secondary me-2'>{t('sip-batal')}</Button>
                          </Link>
                          {btnLoading ? (
                            <Button className='btn btn-primary me-2' disabled>
                              <Spinner animation='border' size='sm' />
                            </Button>
                          ) : <>
                              {
                                !([1,2,3].includes(sipStatus)) && <>
                                  <Button className='btn btn-primary' onClick={handleEdit}>
                                    {t('Memperbarui')}
                                  </Button>
                               </> 
                              }
                            </>
                          }
                        </>
                      ) : (
                        <>
                          <Link to={'/management/kontrak'}>
                            <Button className='btn btn-secondary me-2'>
                              {(status == 4 ||
                                status == 6 ||
                                status == 7 ||
                                status == 8 ||
                                status == 9) &&
                                SOSAPNum != null &&
                                roleUser == 'salesAnper'
                                ? t('cancel')
                                : t('Back')}
                            </Button>
                          </Link>
                          <Button
                            hidden={
                              (status == 4 ||
                                status == 6 ||
                                status == 7 ||
                                status == 8 ||
                                status == 9) &&
                                SOSAPNum != null &&
                                hakAkses?.update &&
                                !amandement
                                ? false
                                : true
                            }
                            className='btn btn-primary me-2'
                            onClick={() => editAdditionalText()}
                            disabled={btnLoading}
                          >
                            {btnLoading ? (
                              <Spinner animation='border' variant='light' size='sm' />
                            ) : (
                              'Update'
                            )}
                          </Button>
                        </>
                      )}
                    </div>
                    <div className='d-flex justify-content-end'></div>
                  </div>
                </div>
              ) : (
                <div className='d-flex justify-content-center py-10'>
                  <div className='lds-ellipsis'>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              )}
            </>
          )}

          <Modal show={show} onHide={handleClose} centered scrollable size='xl' backdrop='static'>
            <Modal.Header closeButton>
              <Modal.Title>Detail</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {kontrakDetail?.sector_id == 1 && (
                <Row>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>Sales Org</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail.produsen?.name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail.incoterm1?.code}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          type='text'
                          value={kontrakDetail.province?.region_name}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail.product_type_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('Plant')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={
                            kontrakDetail?.plant_desc
                              ? kontrakDetail?.plant + ' - ' + kontrakDetail?.plant_desc
                              : ''
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>
                          {kontrakDetail.product_type_desc == 'KANTONG/SACK'
                            ? t('sack')
                            : t('Quantum')}
                        </p>
                      </Col>
                      <Col md={7}>
                        {kontrakDetail.product_type_desc == 'KANTONG/SACK' ? (
                          <Form.Control
                            value={
                              i18next.language === 'en'
                                ? parseFloat(kontrakDetail?.fixed_quantum).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) + ' EA'
                                : parseFloat(kontrakDetail?.fixed_quantum).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) + ' EA'
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        ) : (
                          <Form.Control
                            value={
                              (i18next.language === 'en'
                                ? parseFloat(kontrakDetail?.fixed_quantum).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                                : parseFloat(kontrakDetail?.fixed_quantum).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })) + (kontrakDetail?.sector_id === 3 ? ' MT' : ' Ton')
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        )}
                      </Col>
                    </Row>

                    <Row className='mb-4'>
                      <Col sm={5}>
                        <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                      </Col>
                      <Col sm={7}>
                        <Form.Control
                          size='sm'
                          type='text'
                          id='shipping'
                          value={
                            kontrakDetail?.shipping_tolerance_contract != '0'
                              ? kontrakDetail?.shipping_tolerance_contract + ' %'
                              : ''
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail?.payment_type_1_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('keterangan')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={t(kontrakDetail?.payment_note)}
                          as='textarea'
                          disabled
                          size='sm'
                          style={{ height: '40px' }}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={
                            kontrakDetail.end_user_multiple
                              ? handleShowValue(kontrakDetail.end_user)
                              : kontrakDetail.end_user
                            // kontrakDetail.end_user_detail?.name
                            //   ? kontrakDetail.end_user_detail?.name
                            //   : kontrakDetail.end_user
                          }
                          as='textarea'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={t(kontrakDetail.sector?.name)}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                      </Col>
                      <Col md={7}>
                        {kontrakDetail?.incoterm2 == null ? (
                          <Form.Control
                            value={
                              kontrakDetail?.incoterm2_id == null ||
                                kontrakDetail?.incoterm2_id == '0'
                                ? ''
                                : kontrakDetail?.incoterm2_id
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        ) : (
                          <Form.Control
                            value={kontrakDetail?.incoterm2?.code}
                            type='text'
                            disabled
                            size='sm'
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          type='text'
                          value={kontrakDetail.city?.city_name}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail.product_name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('sub-order-spek')}</p>
                      </Col>
                      <Col md={7}>
                        <FieldProductSpec data={kontrakDetail.product_spec} type='editor' />
                      </Col>
                    </Row>
                    <Row className='mb-2'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>
                          {t('sub-order-hargaD')}/
                          {kontrakDetail.product_type_desc == 'KANTONG/SACK' ? kontrakDetail.unit : 'Ton'}
                        </p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={
                            'Rp ' + (i18next.language === 'en'
                              ? parseInt(kontrakDetail?.price_contract).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                              : parseInt(kontrakDetail?.price_contract).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })
                            )}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    {/* <Row className='mb-5'>
                      <Col sm={5}>
                        <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                      </Col>
                      <Col sm={7} className='d-flex justify-content-start'>
                        <Form.Check
                          reverse
                          name='ppn'
                          className='mt-4 mb-2'
                          type='checkbox'
                          id='ckbox-ppn'
                          checked={kontrakDetail?.include_ppn}
                        />
                      </Col>
                    </Row> */}
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail?.payment_type_2_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('segment')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          type='text'
                          value={t(kontrakDetail.segment_name)}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail?.notes}
                          type='text'
                          as='textarea'
                          style={{ height: '40px' }}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    {kontrakDetail?.sector_id != 2 && <>
                      <Row className='mb-4'>
                        <Col md={5}>
                          <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={kontrakDetail.amandement_notes}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={5}>
                          <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={kontrakDetail.extension_date}
                            type={kontrakDetail.extension_date ? 'date' : 'text'}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                    </>}
                  </Col>
                </Row>
              )}

              {kontrakDetail?.sector_id == 2 && (
                <Row>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>Sales Org</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail.produsen?.name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail.incoterm1?.code}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          type='text'
                          value={kontrakDetail.province?.region_name}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail.plant_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail.product_name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>
                          {kontrakDetail.product_type_desc == 'KANTONG/SACK'
                            ? t('sack')
                            : t('Quantum')}
                        </p>
                      </Col>
                      <Col md={7}>
                        {kontrakDetail.product_type_desc == 'KANTONG/SACK' ? (
                          <Form.Control
                            value={
                              i18next.language === 'en'
                                ? parseFloat(kontrakDetail?.quantum_contract).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) + ' EA'
                                : parseFloat(kontrakDetail?.quantum_contract).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) + ' EA'
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        ) : (
                          <Form.Control
                            value={
                              i18next.language === 'en'
                                ? parseFloat(kontrakDetail?.quantum_contract).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) + ' Ton'
                                : parseFloat(kontrakDetail?.quantum_contract).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) + ' Ton'
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail?.payment_type_1_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('keterangan')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={t(kontrakDetail?.payment_note)}
                          as='textarea'
                          disabled
                          size='sm'
                          style={{ height: '40px' }}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={
                            kontrakDetail.end_user_multiple
                              ? handleShowValue(kontrakDetail.end_user)
                              : kontrakDetail.end_user
                          }
                          as='textarea'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={t(kontrakDetail.sector?.name)}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                      </Col>
                      <Col md={7}>
                        {kontrakDetail?.incoterm2 == null ? (
                          <Form.Control
                            value={
                              kontrakDetail?.incoterm2_id == null ||
                                kontrakDetail?.incoterm2_id == '0'
                                ? ''
                                : kontrakDetail?.incoterm2_id
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        ) : (
                          <Form.Control
                            value={kontrakDetail?.incoterm2?.code}
                            type='text'
                            disabled
                            size='sm'
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          type='text'
                          value={kontrakDetail.city?.city_name}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail.product_type_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('sub-order-spek')}</p>
                      </Col>
                      <Col md={7}>
                        <FieldProductSpec data={kontrakDetail.product_spec} type='editor' />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-hargaD')}/
                          {kontrakDetail.product_type_desc == 'KANTONG/SACK' ? kontrakDetail.unit : 'Ton'}
                        </p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={
                            'Rp ' + (i18next.language === 'en'
                              ? parseInt(kontrakDetail?.price_contract).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                              : parseInt(kontrakDetail?.price_contract).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })
                            )}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail?.payment_type_2_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail?.notes}
                          type='text'
                          as='textarea'
                          style={{ height: '40px' }}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}

              {kontrakDetail?.sector_id == 3 && (
                <Row>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>Sales Org</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail.produsen?.name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail.incoterm1?.code}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          type='text'
                          value={kontrakDetail.province?.region_name}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail.product_type_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('Plant')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail.plant_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>
                          {kontrakDetail.product_type_desc == 'KANTONG/SACK'
                            ? t('sack')
                            : t('Quantum')}
                        </p>
                      </Col>
                      <Col md={7}>
                        {kontrakDetail.product_type_desc == 'KANTONG/SACK' ? (
                          <Form.Control
                            value={
                              i18next.language === 'en'
                                ? parseFloat(kontrakDetail?.fixed_quantum).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) + ' EA'
                                : parseFloat(kontrakDetail?.fixed_quantum).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) + ' EA'
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        ) : (
                          <Form.Control
                            value={
                              i18next.language === 'en'
                                ? parseFloat(kontrakDetail?.fixed_quantum).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) + ' MT'
                                : parseFloat(kontrakDetail?.fixed_quantum).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) + ' MT'
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col sm={5}>
                        <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                      </Col>
                      <Col sm={7}>
                        <Form.Control
                          size='sm'
                          type='text'
                          id='shipping'
                          value={
                            kontrakDetail?.shipping_tolerance_contract != '0'
                              ? kontrakDetail?.shipping_tolerance_contract + ' %'
                              : ''
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail?.payment_type_1_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('keterangan')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={t(kontrakDetail?.payment_note)}
                          as='textarea'
                          disabled
                          size='sm'
                          style={{ height: '40px' }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={t(kontrakDetail.sector?.name)}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                      </Col>
                      <Col md={7}>
                        {kontrakDetail?.incoterm2 == null ? (
                          <Form.Control
                            value={
                              kontrakDetail?.incoterm2_id == null ||
                                kontrakDetail?.incoterm2_id == '0'
                                ? ''
                                : kontrakDetail?.incoterm2_id
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        ) : (
                          <Form.Control
                            value={kontrakDetail?.incoterm2?.code}
                            type='text'
                            disabled
                            size='sm'
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          type='text'
                          value={kontrakDetail.city?.city_name}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail.product_name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('sub-order-spek')}</p>
                      </Col>
                      <Col md={7}>
                        <FieldProductSpec data={kontrakDetail.product_spec} type='editor' />
                      </Col>
                    </Row>
                    <Row className='mb-2'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>
                          {t('sub-order-hargaD')}/
                          {kontrakDetail.product_type_desc == 'KANTONG/SACK' ? kontrakDetail.unit : 'MT'}
                        </p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={
                            'USD ' + (i18next.language === 'en'
                              ? parseFloat(kontrakDetail?.price_contract).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                              : parseFloat(kontrakDetail?.price_contract).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })
                            )}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    {/* <Row className='mb-5'>
                                              <Col sm={5}>
                                                <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                                              </Col>
                                              <Col sm={7} className='d-flex justify-content-start'>
                                                <Form.Check
                                                  reverse
                                                  name='ppn'
                                                  className='mt-4 mb-2'
                                                  type='checkbox'
                                                  id='ckbox-ppn'
                                                  checked={kontrakDetail?.include_ppn}
                                                />
                                              </Col>
                                            </Row> */}
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail?.payment_type_2_desc}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={kontrakDetail?.notes}
                          type='text'
                          as='textarea'
                          style={{ height: '40px' }}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={5}>
                        <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          value={
                            kontrakDetail.end_user_multiple
                              ? handleShowValue(kontrakDetail.end_user)
                              : kontrakDetail.end_user
                          }
                          as='textarea'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    {kontrakDetail?.sector_id != 2 && <>
                      <Row className='mb-4'>
                        <Col md={5}>
                          <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={kontrakDetail.amandement_notes}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={5}>
                          <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={kontrakDetail.extension_date}
                            type={kontrakDetail.extension_date ? 'date' : 'text'}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                    </>}
                  </Col>
                </Row>
              )}
            </Modal.Body>
          </Modal>

          <Modal
            show={showJadwal}
            onHide={() => {
              setShowJadwal(false)
              setJadwalID('')
            }}
            centered
            size='xl'
            backdrop='static'
            keyboard={false}
            scrollable
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {idSektor != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
                {productName} | {quantumContract} {ptypee != '8105' ? 'Ton' : punit}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <AddRemoveJadwal id={jadwalID} is_amendment={'false'} tipeproduct={ptypee} unit={punit} />
            </Modal.Body>
          </Modal>

          <Modal
            size='lg'
            show={showUpload}
            onHide={() => {
              setShowUpload(false)
              setIsPrivate(false)
              setTempRole([])
              setFileBox({})
            }}
            backdrop='static'
            keyboard={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {
                  attachmentType == 'order-item' ? (fileBox?.product_name
                    ? (fileBox.province ? fileBox.province?.region_name : '') +
                    (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                    (fileBox.province ? ' | ' : '') +
                    fileBox.product_name +
                    (fileBox.quantum_contract ? ' | ' + fileBox.quantum_contract + ' Ton' : '')
                    : t('File Box'))
                    : <span>{t('File Box')}</span>
                }
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {loadingSkeleton ? (
                <>
                  <Col lg={6}>
                    <Skeleton count={3} height={30} />
                  </Col>
                </>
              ) : (
                <>
                  {!downloadOnly ? (
                    <Row>
                      <Col sm={6}>
                        <table className='mb-3'>
                          <tr>
                            <td style={{ width: '120px' }}>
                              <h6>{t('order-fileUnggah')}</h6>
                            </td>
                            <td className='w-75'>
                              <InputFile
                                setFileName={setNamaFile}
                                setFiles={setFiles}
                                isBase64={false}
                              />
                            </td>
                          </tr>
                        </table>
                        <table className='mb-3'>
                          <tr>
                            <td style={{ width: '120px' }}>
                              <h6>{t('order-keterangan')}</h6>
                            </td>
                            <td className='w-75'>
                              <Form.Control
                                type='text'
                                id='uploadketerangan'
                                placeholder={t('order-keterangan')}
                                onChange={(e: any) => setDescription(e.target.value)}
                                value={description}
                              />
                            </td>
                          </tr>
                        </table>
                        <table
                          className='mb-3'
                          hidden={roleUser == 'null' || roleUser == null ? true : false}
                        >
                          <tr>
                            <td>
                              <h6 className='me-11'>{t('Private')}</h6>
                            </td>
                            <td className='w-75 d-flex justify-content-start'>
                              <Form.Check
                                reverse
                                name='isPrivate'
                                type='checkbox'
                                className='mt-5 mb-2'
                                onClick={() => {
                                  setIsPrivate(!isPrivate)
                                  setTempRole([])
                                }}
                                id='isPrivate'
                              />
                            </td>
                          </tr>
                        </table>
                        <table className='mb-3' hidden={isPrivate ? false : true}>
                          <tr>
                            <td style={{ width: '120px' }}>
                              <h6>{t('Akses Role')}</h6>
                            </td>
                            <td className='w-75' style={{ maxWidth: '274px' }}>
                              <MultiSelect
                                key={isPrivate.toString()}
                                options={fullRole?.map((item: any) => {
                                  return { label: item.label, value: item.value }
                                })}
                                value={tempRole}
                                onChange={(e: any) => setTempRole(e)}
                                labelledBy='Select'
                              />
                            </td>
                          </tr>
                        </table>
                        <div className='d-flex justify-content-end'>
                          <Button
                            variant='primary'
                            className='w-100'
                            onClick={() => handleUpload()}
                            disabled={btnLoading}
                          >
                            {btnLoading ? (
                              <Spinner animation='border' variant='light' size='sm' />
                            ) : (
                              t('order-kirim')
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <>
                      <p className='fs-5 fw-bold text-center'>{t('data-tidak-ada')}</p>
                    </>
                  )}
                  {allFiles.length < 1 || allFiles.length == undefined ? (
                    <></>
                  ) : (
                    <>
                      <div className='table-responsive mt-4 bdr'>
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                          <thead className='fw-bold border-bottom'>
                            <tr className=''>
                              <th className='text-center'>{t('order-noo')}</th>
                              <th className='text-center'>{t('order-keterangan')}</th>
                              <th className='text-center'>{t('order-tglUpload')}</th>
                              {/* <th className='text-center'>{t('User Code')}</th> */}
                              <th className='text-center'>{t('order-user')}</th>
                              <th className='text-center'>{t('Akses Role')}</th>
                              <th className='text-center'>{t('order-aksi')}</th>
                            </tr>
                          </thead>
                          {allFiles.map((data: any, _index: any) => (
                            <tbody key={data?.id ?? _index}>
                              <tr className=''>
                                <td className='text-center'>
                                  <label>{_index + 1}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{data.description}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{dateformat(data.updated_at)}</label>
                                </td>
                                {/* <td className='text-center'>
                                  <label>
                                    {data.user?.customer_code || data.user?.nama_pengguna}
                                  </label>
                                </td> */}
                                <td className='text-center'>
                                  {data.user?.customer_code == null ? (
                                    <label>{data.user?.name}</label>
                                  ) : (
                                    <label>{data.user?.customer?.name}</label>
                                  )}
                                </td>
                                <td className='text-center'>
                                  {data.private ? (
                                    data.roles.length > 0 ? (
                                      <PopoverText
                                        content={handleShowRoleName(data.roles)}
                                        index={_index}
                                        className='desc-slice'
                                      />
                                    ) : (
                                      'Private'
                                    )
                                  ) : (
                                    'Public'
                                  )}
                                </td>
                                <td className='text-center'>
                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('order-lampiran')}
                                    onClick={() =>
                                      handleDownloadAttachment(
                                        data.file_path
                                      )
                                    }
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/arrow-down-square-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                  {(hakAkses?.attachment_delete ||
                                    CheckSameIDAttachment(data.user_role_flag)) && (
                                      <button
                                        onClick={() => deleteAttachment(data.id)}
                                        className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                                        data-bs-toggle='tooltip'
                                        data-bs-placement='top'
                                        data-bs-trigger='hover'
                                        title={t('Hapus')}
                                      >
                                        <KTSVG
                                          path='/media/icons/duotune/trash-fill.svg'
                                          className='svg-icon-3'
                                        />
                                      </button>
                                    )}
                                </td>
                              </tr>
                            </tbody>
                          ))}
                        </table>
                      </div>
                    </>
                  )}
                </>
              )}
            </Modal.Body>
          </Modal>

          <Modal show={show2} onHide={handleClose2} centered>
            <Modal.Header closeButton>
              <Modal.Title>{t('alasan-tolak')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className='d-flex justify-content-center'>
                <h5>{reasonReject}</h5>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            show={show1}
            onHide={() => {
              setKontrakDetail({})
              setShow1(false)
              setSalesOption('')
            }}
            centered
            backdrop='static'
            keyboard={false}
            size='lg'
          >
            <Modal.Header closeButton>
              <Modal.Title>Edit Item</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {loadingModal ? (
                <div className='d-flex justify-content-center'>
                  <Spinner animation='border' variant='primary' />
                </div>
              ) : (
                <>
                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label>{t('sub-order-gudang')}</Form.Label>
                    <Select
                      key={plant}
                      placeholder={t('pilih') + ' ' + t('sub-order-gudang')}
                      options={fullPlant}
                      onChange={(e: any) => {
                        separator(e.value, setPlant, setPlantDesc)
                        setPlantt(e.value)
                        const tmp = e.value?.split('~#~')
                        setKontrakDetail((state: any) => ({
                          ...state,
                          plant: tmp[0],
                          plant_desc: tmp[1],
                        }))
                      }}
                      defaultValue={fullPlant[fullPlant.findIndex((x: any) => x.value == plantt)]}
                    />
                  </Form.Group>
                  { idSektor == 3 && <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label>{t('sub-order-gudang')} (EN)</Form.Label>
                    <Form.Control
                      aria-label='Default select example'
                      value={plantNameEn}
                      style={{ height: '40px' }}
                      onChange={(e: any) => {
                        const plantEn = e.target.value
                        setPlantNameEn(plantEn)
                        setKontrakDetail((state: any) => ({
                          ...state,
                          plant_desc_en: plantEn,
                        }))
                      }}
                      key={plant + matNumber}
                    />
                  </Form.Group> }
                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label>{t('storage location')}</Form.Label>
                    <Form.Select
                      aria-label='Default select example'
                      onChange={(e: any) => {
                        separator(e.target.value, setslocId, setslocDesc)
                      }}
                      key={plant + matNumber}
                    >
                      <option value=''>
                        {t('pilih')} {t('storage location')}
                      </option>
                      {fullsloc?.map((item: any) => {
                        return (
                          <>
                            {item.sloc == slocId ? (
                              <option selected value={item.sloc + '~#~' + item.sloc_description}>
                                {item.sloc + ' - ' + item.sloc_description}
                              </option>
                            ) : (
                              <option value={item.sloc + '~#~' + item.sloc_description}>
                                {item.sloc + ' - ' + item.sloc_description}
                              </option>
                            )}
                          </>
                        )
                      })}
                    </Form.Select>
                  </Form.Group>
                  {plantt && (
                    <>
                      <Form.Group className='mb-3' controlId='formBasicEmail'>
                        <Form.Label>{t('kontrak-jenis')}</Form.Label>
                        <Form.Select
                          aria-label='Default select example'
                          onChange={(e: any) => separator(e.target.value, setMatgroup, setMatgroudesc)}
                        >
                          <option value=''>
                            {t('pilih')} {t('kontrak-jenis')}
                          </option>
                          {listMaterial?.map((item: any) => {
                            return (
                              <>
                                {item.material_group == matgroup ? (
                                  <option
                                    selected
                                    value={item.material_group + '~#~' + item.material_group_desc}
                                  >
                                    {item.material_group + ' - ' + item.material_group_desc}
                                  </option>
                                ) : (
                                  <option
                                    value={item.material_group + '~#~' + item.material_group_desc}
                                  >
                                    {item.material_group + ' - ' + item.material_group_desc}
                                  </option>
                                )}
                              </>
                            )
                          })}
                        </Form.Select>
                      </Form.Group>
                      <Form.Group className='mb-3' controlId='formBasicEmail'>
                        <Form.Label>{t('sub-order-produk')}</Form.Label>
                        <Form.Select
                          aria-label='Default select example'
                          onChange={(e: any) => {
                            const _split = e.target.value.split('~#~')
                            setMatUnit(_split[2])
                            separator(e.target.value, setMatDesc, setMatNumber)
                          }}
                        >
                          <option value=''>
                            {t('pilih')} {t('sub-order-produk')}
                          </option>
                          {listProduct?.map((item: any) => {
                            return (
                              <option
                                key={item.material_number}
                                selected={item.material_number == matNumber}
                                value={[
                                  item.material_description,
                                  item.material_number,
                                  item.base_of_measure,
                                ].join('~#~')}
                              >
                                {parseInt(item.material_number) + " - " + item.material_description}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </Form.Group>
                      { idSektor == 3 && <Form.Group className='mb-3' controlId='formBasicEmail'>
                        <Form.Label>{t('sub-order-produk')} (EN)</Form.Label>
                        <Form.Control
                          aria-label='Default select example'
                          as='textarea'
                          value={productNameEn}
                          style={{ height: '40px' }}
                          onChange={(e: any) => {
                            const prodeN = e.target.value
                            setProductNameEn(prodeN)
                            setKontrakDetail((state: any) => ({
                              ...state,
                              material_desc_en: prodeN,
                            }))
                          }}
                          key={plant + matNumber}
                        />
                      </Form.Group> }
                      <Form.Group className='mb-3' controlId='formBasicEmail'>
                        <Form.Label>{t('sub-order-spek')}</Form.Label>
                        <div>
                          <RichText
                            containerClassName='mt-4'
                            content={spec}
                            onUpdate={({ editor }) => {
                              setSpec(editor.getHTML())
                              const product_spec = editor.getHTML()
                            }}
                          >
                            &nbsp;
                          </RichText>
                        </div>
                      </Form.Group>
                      <Form.Group className='mb-3' controlId='formBasicEmail'>
                        <Form.Label>{t('kontrak-harga')}</Form.Label>
                        <InputGroup>
                          <InputGroup.Text id='basic-addon1'>Rp</InputGroup.Text>
                          <CurrencyInput
                            id='rp'
                            placeholder={t('kontrak-harga')}
                            className='form-control form-control-sm'
                            defaultValue={hargaEdit}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setHargaEdit(parseFloat(value?.replace(/,/g, '.')))
                            }}
                            decimalsLimit={-1}
                          />
                        </InputGroup>
                      </Form.Group>
                      <Form.Group className='mb-3'>
                        <Form.Label>
                          {t('CREATE_CONTRACT.EDIT_ITEM_MODAL.STATUS_PRICE_LABEL')}
                        </Form.Label>
                        <Form.Control
                          defaultValue={kontrakDetail?.include_ppn ? 'include PPN' : 'exclude PPN'}
                          disabled
                        />
                      </Form.Group>

                      <Row>
                        <Col md='6'>
                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <Form.Label>
                              {t('CREATE_CONTRACT.EDIT_ITEM_MODAL.TOTAL_QUANTUM_LABEL')}
                            </Form.Label>
                            <Form.Control
                              aria-label='Default select example'
                              defaultValue={
                                parseFloat(kontrakDetail?.quantum_contract_sip) -
                                parseFloat(kontrakDetail?.quantum_contract) ?? ''
                              }
                              disabled
                            />
                          </Form.Group>
                        </Col>
                        <Col md='6'>
                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <Form.Label>{t('sisaquantum')}</Form.Label>
                            <Form.Control
                              aria-label='Default select example'
                              defaultValue={
                                parseFloat(kontrakDetail?.quantum_contract) +
                                parseFloat(kontrakDetail?.left_over_qty_sip)
                              }
                              disabled
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md='6'>
                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <Form.Label>
                              {t('CREATE_CONTRACT.EDIT_ITEM_MODAL.QUANTUM_SIP_LABEL')}
                            </Form.Label>
                            <InputGroup>
                              <CurrencyInput
                                id='ton'
                                placeholder='Quantum'
                                className='form-control form-control-sm'
                                disabled
                                defaultValue={kontrakDetail?.quantum_sip ?? ''}
                                decimalSeparator={language === 'en' ? '.' : ','}
                                groupSeparator={language === 'en' ? ',' : '.'}
                                onValueChange={(value: any) => {
                                  setQuantumEdit(parseFloat(value?.replace(/,/g, '.')))
                                }}
                                decimalsLimit={3}
                              />
                              <InputGroup.Text id='basic-addon1'>Ton</InputGroup.Text>
                            </InputGroup>
                          </Form.Group>
                        </Col>
                        <Col md='6'>
                          <Form.Group className='mb-3'>
                            <Form.Label>
                              {t('CREATE_CONTRACT.EDIT_ITEM_MODAL.TOLERANCE_SIP_LABEL')}
                            </Form.Label>
                            <InputGroup>
                              <CurrencyInput
                                disabled
                                className='form-control form-control-sm'
                                defaultValue={kontrakDetail?.shipping_tolerance ?? ''}
                                decimalSeparator={language === 'en' ? '.' : ','}
                                groupSeparator={language === 'en' ? ',' : '.'}
                                decimalsLimit={3}
                              />
                              <InputGroup.Text>%</InputGroup.Text>
                            </InputGroup>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md='6'>
                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <Form.Label>
                              {t('CREATE_CONTRACT.EDIT_ITEM_MODAL.SUBMISSION_QUANTUM_LABEL')}
                            </Form.Label>
                            <InputGroup>
                              <CurrencyInput
                                id='ton'
                                placeholder='Quantum'
                                className='form-control form-control-sm'
                                defaultValue={kontrakDetail.fixed_quantum_edit || kontrakDetail.quantum_contract || '0'}
                                decimalSeparator={language === 'en' ? '.' : ','}
                                groupSeparator={language === 'en' ? ',' : '.'}
                                onValueChange={(value: any) => {
                                  setQuantumEdit(parseFloat(value?.replace(/,/g, '.')))
                                  setKontrakDetail((state: any) => ({
                                    ...state,
                                    fixed_quantum_edit: parseFloat(value?.replace(/,/g, '.')),
                                  }))
                                }}
                                decimalsLimit={3}
                              />
                              <InputGroup.Text id='basic-addon1'>
                                {kontrakDetail?.product_type == '8105' ? kontrakDetail?.unit : 'Ton'}
                              </InputGroup.Text>
                            </InputGroup>
                          </Form.Group>
                        </Col>
                        <Col md='6'>
                          <Form.Group className='mb-3'>
                            <Form.Label>
                              {t('CREATE_CONTRACT.EDIT_ITEM_MODAL.SHIPPING_TOLERANCE_LABEL')}
                            </Form.Label>
                            <InputGroup>
                              <CurrencyInput
                                className='form-control form-control-sm'
                                defaultValue={kontrakDetail?.shipping_tolerance ?? ''}
                                decimalSeparator={language === 'en' ? '.' : ','}
                                groupSeparator={language === 'en' ? ',' : '.'}
                                decimalsLimit={3}
                                onValueChange={(value: any) => {
                                  setKontrakDetail((state: any) => ({
                                    ...state,
                                    shipping_tolerance_contract: parseFloat(
                                      value?.replace(/,/g, '.')
                                    ),
                                  }))
                                }}
                              />
                              <InputGroup.Text>%</InputGroup.Text>
                            </InputGroup>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Form.Group className='mb-3' controlId='formBasicEmail'>
                        <Form.Label>{t('CREATE_CONTRACT.EDIT_ITEM_MODAL.NOTE_LABEL')}</Form.Label>
                        <Form.Control
                          aria-label='Default select example'
                          as='textarea'
                          defaultValue={ordersubdetail[tempIndex].at_sales_option}
                          style={{ height: '40px' }}
                          onChange={(e: any) => setSalesOption(e.target.value)}
                          key={plant + matNumber}
                        />
                      </Form.Group>
                    </>
                  )}
                  <div className='d-flex justify-content-end mt-5'>
                    <Button onClick={() => handleEditPlant()}>{t('Save')}</Button>
                  </div>
                </>
              )}
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  )
}

export { KontrakDetail }
